"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6861],{

/***/ 83955:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A": function() { return /* binding */ fetchFollowingFeeds; },
/* harmony export */   "g": function() { return /* binding */ fetchHomeFeeds; }
/* harmony export */ });
/* harmony import */ var ___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(39322);
/* harmony import */ var _utils_misc__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(45874);
/* harmony import */ var _chatbot__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(23082);
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var __generator = undefined && undefined.__generator || function(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};



var _populate = function(feeds, type, objects) {
    return feeds.map(function(item) {
        var object = objects.find(function(s) {
            return s.id === item.objectId && type === item.objectType;
        });
        if (object) {
            return _objectSpreadProps(_objectSpread({}, item), {
                id: "".concat(item.objectType, "-").concat(item.objectId),
                object: object
            });
        }
        return _objectSpreadProps(_objectSpread({}, item), {
            id: "".concat(item.objectType, "-").concat(item.objectId)
        });
    });
};
var fetchFollowingFeeds = function() {
    var _ref = _asyncToGenerator(function() {
        var page, perPage, data, storyIds, postIds, feeds, ref, stories, ref1, posts;
        var _arguments = arguments;
        return __generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    page = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : 1, perPage = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : 20;
                    return [
                        4,
                        ___WEBPACK_IMPORTED_MODULE_0__/* .api.get */ .hi.get("/users/me/following-feeds/".concat((0,_utils_misc__WEBPACK_IMPORTED_MODULE_1__/* .toQueryString */ .UK)({
                            page: page,
                            perPage: perPage
                        })))
                    ];
                case 1:
                    data = _state.sent().data;
                    storyIds = data.items.filter(function(item) {
                        return item.objectType === "story";
                    }).map(function(item) {
                        return item.objectId;
                    });
                    postIds = data.items.filter(function(item) {
                        return item.objectType === "community";
                    }).map(function(item) {
                        return item.objectId;
                    });
                    feeds = data.items;
                    if (!(storyIds.length > 0)) return [
                        3,
                        3
                    ];
                    return [
                        4,
                        ___WEBPACK_IMPORTED_MODULE_0__/* .api.get */ .hi.get("/stories/".concat((0,_utils_misc__WEBPACK_IMPORTED_MODULE_1__/* .toQueryString */ .UK)({
                            storyIds: storyIds.join(",")
                        })))
                    ];
                case 2:
                    ref = _state.sent(), stories = ref.data;
                    feeds = _populate(feeds, "story", stories);
                    _state.label = 3;
                case 3:
                    if (!(postIds.length > 0)) return [
                        3,
                        5
                    ];
                    return [
                        4,
                        ___WEBPACK_IMPORTED_MODULE_0__/* .api.get */ .hi.get("/communities/".concat((0,_utils_misc__WEBPACK_IMPORTED_MODULE_1__/* .toQueryString */ .UK)({
                            communityIds: postIds.join(",")
                        })))
                    ];
                case 4:
                    ref1 = _state.sent(), posts = ref1.data;
                    feeds = _populate(feeds, "community", posts);
                    _state.label = 5;
                case 5:
                    return [
                        2,
                        _objectSpreadProps(_objectSpread({}, data), {
                            items: feeds
                        })
                    ];
            }
        });
    });
    return function fetchFollowingFeeds() {
        return _ref.apply(this, arguments);
    };
}();
var _populateHome = function(feeds, objects) {
    return feeds.map(function(item) {
        var object = objects.find(function(s) {
            return s.id === item.media_id;
        });
        if (object) {
            return _objectSpreadProps(_objectSpread({}, item), {
                post: object
            });
        }
        return item;
    });
};
var fetchHomeFeeds = function() {
    var _ref = _asyncToGenerator(function(feed_code, query) {
        var page, perPage, data, result, groundIds, feeds, data1;
        var _arguments = arguments;
        return __generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    page = _arguments.length > 2 && _arguments[2] !== void 0 ? _arguments[2] : 1, perPage = _arguments.length > 3 && _arguments[3] !== void 0 ? _arguments[3] : 20;
                    return [
                        4,
                        _chatbot__WEBPACK_IMPORTED_MODULE_2__/* .CHAT_BOT_API.get */ .kq.get(query ? "/character-feeds/".concat(feed_code, "/").concat(query, "&page=").concat(page, "&per_page=").concat(perPage) : "/character-feeds/".concat(feed_code, "/").concat((0,_utils_misc__WEBPACK_IMPORTED_MODULE_1__/* .toQueryString */ .UK)({
                            page: page,
                            perPage: perPage
                        })))
                    ];
                case 1:
                    data = _state.sent().data;
                    result = data.result;
                    groundIds = result.items.filter(function(item) {
                        return item.media_type === "playground";
                    }).map(function(item) {
                        return item.media_id;
                    });
                    feeds = result.items;
                    if (!(groundIds.length > 0)) return [
                        3,
                        3
                    ];
                    return [
                        4,
                        ___WEBPACK_IMPORTED_MODULE_0__/* .api.get */ .hi.get("/play/characters/all/communities/".concat((0,_utils_misc__WEBPACK_IMPORTED_MODULE_1__/* .toQueryString */ .UK)({
                            community_ids: groundIds.join(",")
                        })))
                    ];
                case 2:
                    data1 = _state.sent().data;
                    feeds = _populateHome(feeds, data1.items);
                    _state.label = 3;
                case 3:
                    return [
                        2,
                        _objectSpreadProps(_objectSpread({}, result), {
                            items: feeds
                        })
                    ];
            }
        });
    });
    return function fetchHomeFeeds(feed_code, query) {
        return _ref.apply(this, arguments);
    };
}();


/***/ }),

/***/ 23468:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(8683);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(11717);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(71618);
/* harmony import */ var next_i18next__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(26950);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(39953);
/* harmony import */ var chatie_design_system__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9150);
/* harmony import */ var chatie_design_system_icon__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(82740);
/* harmony import */ var _components_common_ActionSheet__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(83898);
/* harmony import */ var _components_common_ImageCarousel__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(16482);
/* harmony import */ var _components_modal_ImageModal__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(11502);
/* harmony import */ var _styles_css__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(96964);
/* harmony import */ var _utils_community__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(85791);
/* harmony import */ var _utils_date__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(9987);
/* harmony import */ var _utils_misc__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(45874);
/* harmony import */ var _common_Avatar__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(81649);
/* harmony import */ var _user_Nickname__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(87682);
/* harmony import */ var _MentionText__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(26581);
/* harmony import */ var _PollDisplay__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(89831);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  position: relative;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  ",
        ";\n  color: ",
        ";\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: ",
        "px;\n\n    .profile {\n      display: flex;\n      align-items: center;\n    }\n\n    .nickname {\n      margin-left: ",
        "px;\n\n      .fixedContainer {\n        display: flex;\n        align-items: center;\n        gap: ",
        "px;\n      }\n\n      small {\n        display: block;\n        margin-top: ",
        "px;\n        color: ",
        ";\n        ",
        ";\n      }\n    }\n  "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n  ",
        "\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n  color: ",
        ";\n\n  &:before {\n    content: '\\00a0';\n  }\n"
    ], [
        "\n  color: ",
        ";\n\n  &:before {\n    content: '\\\\00a0';\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n  margin-top: ",
        "px;\n\n  ",
        " {\n    max-width: 400px;\n    margin-left: auto;\n    margin-right: auto;\n    border-radius: 12px;\n    overflow: hidden;\n  }\n  ",
        " {\n    max-width: 480px;\n    border-radius: 16px;\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _taggedTemplateLiteral([
        "\n  margin-top: ",
        "px;\n  color: ",
        ";\n\n  button {\n    ",
        ";\n  }\n\n  button + button {\n    margin-left: ",
        "px;\n  }\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}

















var postCSS = (0,_emotion_react__WEBPACK_IMPORTED_MODULE_14__.css)(_templateObject());
var postFixedCSS = function(theme) {
    return (0,_emotion_react__WEBPACK_IMPORTED_MODULE_14__.css)(_templateObject1(), chatie_design_system__WEBPACK_IMPORTED_MODULE_2__/* .Typography.body12 */ .ZT.body12, theme.var.gray600);
};
var postUserCSS = function(theme) {
    return (0,_emotion_react__WEBPACK_IMPORTED_MODULE_14__.css)(_templateObject2(), chatie_design_system__WEBPACK_IMPORTED_MODULE_2__/* .Spacing.medium */ .Ki.medium, chatie_design_system__WEBPACK_IMPORTED_MODULE_2__/* .Spacing.xsmall */ .Ki.xsmall, chatie_design_system__WEBPACK_IMPORTED_MODULE_2__/* .Spacing.xxsmall */ .Ki.xxsmall, chatie_design_system__WEBPACK_IMPORTED_MODULE_2__/* .Spacing.xxsmall */ .Ki.xxsmall, theme.var.gray500, chatie_design_system__WEBPACK_IMPORTED_MODULE_2__/* .Typography.body12 */ .ZT.body12);
};
var postContentCSS = (0,_emotion_react__WEBPACK_IMPORTED_MODULE_14__.css)(_templateObject3(), chatie_design_system__WEBPACK_IMPORTED_MODULE_2__/* .Typography.body14 */ .ZT.body14);
var postContentMoreBtnCSS = function(theme) {
    return (0,_emotion_react__WEBPACK_IMPORTED_MODULE_14__.css)(_templateObject4(), theme.var.gray500);
};
var postPictureCSS = (0,_emotion_react__WEBPACK_IMPORTED_MODULE_14__.css)(_templateObject5(), chatie_design_system__WEBPACK_IMPORTED_MODULE_2__/* .Spacing.small */ .Ki.small, _styles_css__WEBPACK_IMPORTED_MODULE_7__/* .media.tablet */ .BC.tablet, _styles_css__WEBPACK_IMPORTED_MODULE_7__/* .media.desktop */ .BC.desktop);
var postButtonCSS = function(theme) {
    return (0,_emotion_react__WEBPACK_IMPORTED_MODULE_14__.css)(_templateObject6(), chatie_design_system__WEBPACK_IMPORTED_MODULE_2__/* .Spacing.xsmall */ .Ki.xsmall, theme.var.gray500, chatie_design_system__WEBPACK_IMPORTED_MODULE_2__/* .Typography.body12 */ .ZT.body12, chatie_design_system__WEBPACK_IMPORTED_MODULE_2__/* .Spacing.xsmall */ .Ki.xsmall);
};
var Post = function(_param) {
    var tmp = _param.clip, isClip = tmp === void 0 ? false : tmp, onLike = _param.onLike, isMyPage = _param.isMyPage, handleActionSheet = _param.handleActionSheet, onPollVote = _param.onPollVote, _post = _objectWithoutProperties(_param, [
        "clip",
        "onLike",
        "isMyPage",
        "handleActionSheet",
        "onPollVote"
    ]);
    var post = _post;
    var id = post.id, user = post.user, content = post.content, likeCount = post.likeCount, commentCount = post.commentCount, isFixed = post.isFixed, isLiked = post.isLiked, created = post.created;
    var t = (0,next_i18next__WEBPACK_IMPORTED_MODULE_0__/* .useTranslation */ .$G)().t;
    var theme = (0,_emotion_react__WEBPACK_IMPORTED_MODULE_15__.u)();
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), isContentOpen = ref[0], setContentOpen = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), isImageModalOpen = ref1[0], setImageModalOpen = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(0), imageModalIndex = ref2[0], setImageModalIndex = ref2[1];
    var postImages = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        return (0,_utils_community__WEBPACK_IMPORTED_MODULE_16__/* .getPostImages */ .I)(post);
    }, [
        post
    ]);
    var hasImages = postImages.length > 0;
    var ref3 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        return (0,_utils_misc__WEBPACK_IMPORTED_MODULE_9__/* .trimStringByLine */ .z_)(content);
    }, [
        content
    ]), content1 = ref3[0], content2 = ref3[1];
    var ref4 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(isMyPage ? [
        {
            label: t("수정하기"),
            value: "modify"
        },
        {
            label: t("삭제하기"),
            value: "delete",
            isDanger: true
        }, 
    ] : [
        {
            label: t("신고하기"),
            value: "report"
        }
    ]), actions = ref4[0];
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__.jsxs)("article", {
        css: postCSS,
        children: [
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__.jsxs)("div", {
                css: postUserCSS,
                children: [
                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__.jsxs)("div", {
                        className: "profile",
                        children: [
                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__.jsx)(_common_Avatar__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .ZP, _objectSpread({
                                size: _common_Avatar__WEBPACK_IMPORTED_MODULE_10__/* .AvatarSize.medium */ .DZ.medium
                            }, user)),
                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__.jsxs)("div", {
                                className: "nickname",
                                children: [
                                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__.jsxs)("div", {
                                        className: "fixedContainer",
                                        children: [
                                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__.jsx)("h6", {
                                                children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__.jsx)(_user_Nickname__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, _objectSpread({}, user))
                                            }),
                                            isFixed && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__.jsxs)("p", {
                                                css: postFixedCSS,
                                                className: "icon-text",
                                                children: [
                                                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__.jsx)(chatie_design_system_icon__WEBPACK_IMPORTED_MODULE_3__/* .Icon */ .JO, {
                                                        icon: chatie_design_system_icon__WEBPACK_IMPORTED_MODULE_3__/* .PinFill */ .Ft,
                                                        size: chatie_design_system__WEBPACK_IMPORTED_MODULE_2__/* .Sizes.small */ .u8.small,
                                                        color: theme.var.gray600
                                                    }),
                                                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__.jsx)("span", {
                                                        children: t("고정됨")
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__.jsx)("small", {
                                        children: (0,_utils_date__WEBPACK_IMPORTED_MODULE_8__/* .formatDate */ .p6)(created)
                                    })
                                ]
                            })
                        ]
                    }),
                    handleActionSheet && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__.jsx)(_components_common_ActionSheet__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                        name: "post-card-action-".concat(post.id),
                        options: actions,
                        onSelect: function(value) {
                            return handleActionSheet(value, id);
                        },
                        children: function(open) {
                            return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__.jsx)("button", {
                                className: "icon-btn",
                                onClick: open,
                                children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__.jsx)(chatie_design_system_icon__WEBPACK_IMPORTED_MODULE_3__/* .Icon */ .JO, {
                                    icon: chatie_design_system_icon__WEBPACK_IMPORTED_MODULE_3__/* .VerticalEllipsis */ .oR,
                                    color: theme.var.gray400,
                                    size: chatie_design_system__WEBPACK_IMPORTED_MODULE_2__/* .Sizes.small */ .u8.small
                                })
                            });
                        }
                    })
                ]
            }),
            isClip ? /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__.jsxs)("p", {
                css: postContentCSS,
                className: "multiline",
                children: [
                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__.jsx)(_MentionText__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .ZP, {
                        content: content1
                    }),
                    isContentOpen && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__.jsx)(_MentionText__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .ZP, {
                        content: content2
                    }),
                    !isContentOpen && content2 && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__.jsxs)("button", {
                        css: postContentMoreBtnCSS,
                        className: "text-btn",
                        onClick: function(e) {
                            e.stopPropagation();
                            setContentOpen(true);
                        },
                        children: [
                            "...",
                            t("더보기")
                        ]
                    })
                ]
            }) : /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__.jsx)("p", {
                css: postContentCSS,
                className: "multiline",
                children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__.jsx)(_MentionText__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .ZP, {
                    content: content
                })
            }),
            post.poll && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__.jsx)(_PollDisplay__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
                poll: post.poll,
                communityId: id,
                onVote: function(updatedPoll) {
                    onPollVote === null || onPollVote === void 0 ? void 0 : onPollVote(_objectSpreadProps(_objectSpread({}, post), {
                        poll: updatedPoll
                    }));
                }
            }),
            hasImages && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__.jsx)("div", {
                css: postPictureCSS,
                children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__.jsx)(_components_common_ImageCarousel__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                    images: postImages,
                    onClickImage: function(index) {
                        setImageModalIndex(index);
                        setImageModalOpen(true);
                    }
                })
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__.jsxs)("div", {
                css: postButtonCSS,
                children: [
                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__.jsxs)("button", {
                        className: "text-btn icon-text",
                        onClick: function(e) {
                            e.stopPropagation();
                            onLike === null || onLike === void 0 ? void 0 : onLike(post);
                        },
                        children: [
                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__.jsx)(chatie_design_system_icon__WEBPACK_IMPORTED_MODULE_3__/* .Icon */ .JO, {
                                icon: isLiked ? chatie_design_system_icon__WEBPACK_IMPORTED_MODULE_3__/* .HeartFill */ .Ic : chatie_design_system_icon__WEBPACK_IMPORTED_MODULE_3__/* .Heart */ .YK,
                                size: chatie_design_system__WEBPACK_IMPORTED_MODULE_2__/* .Sizes.small */ .u8.small,
                                color: isLiked ? theme.colors.red500 : theme.var.gray500
                            }),
                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__.jsx)("span", {
                                children: likeCount != null && likeCount > 0 ? likeCount : t("좋아요")
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__.jsxs)("button", {
                        className: "text-btn icon-text",
                        children: [
                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__.jsx)(chatie_design_system_icon__WEBPACK_IMPORTED_MODULE_3__/* .Icon */ .JO, {
                                icon: chatie_design_system_icon__WEBPACK_IMPORTED_MODULE_3__/* .Comment */ .sv,
                                size: chatie_design_system__WEBPACK_IMPORTED_MODULE_2__/* .Sizes.small */ .u8.small,
                                color: theme.var.gray500
                            }),
                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__.jsx)("span", {
                                children: commentCount != null && commentCount > 0 ? commentCount : t("댓글달기")
                            })
                        ]
                    })
                ]
            }),
            hasImages && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__.jsx)(_components_modal_ImageModal__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                images: postImages,
                initialIndex: imageModalIndex,
                open: isImageModalOpen,
                onClose: function() {
                    return setImageModalOpen(false);
                }
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Post);


/***/ }),

/***/ 45861:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(8683);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11717);
/* harmony import */ var chatie_design_system__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9150);
/* harmony import */ var _styles_css__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(96964);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  position: relative;\n  max-width: inherit;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}




var safeareaCSS = (0,_emotion_react__WEBPACK_IMPORTED_MODULE_2__.css)(_templateObject());
var SafeArea = function(param) {
    var className = param.className, top = param.top, bottom = param.bottom, children = param.children;
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("div", {
        className: className,
        css: [
            safeareaCSS,
            top ? (0,_styles_css__WEBPACK_IMPORTED_MODULE_1__/* .safeArea */ .BI)("top") : undefined,
            bottom ? (0,_styles_css__WEBPACK_IMPORTED_MODULE_1__/* .safeArea */ .BI)("bottom", "padding", chatie_design_system__WEBPACK_IMPORTED_MODULE_0__/* .Spacing.medium */ .Ki.medium) : undefined, 
        ],
        children: children
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (SafeArea);


/***/ }),

/***/ 21567:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(8683);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11717);
/* harmony import */ var chatie_design_system__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9150);
/* harmony import */ var _Frame__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(19827);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  padding: ",
        "px ",
        "px;\n  display: grid;\n  box-sizing: content-box;\n  height: 72px;\n  grid-template-columns: 96px 1fr 1fr;\n  grid-template-rows: repeat(3, 1fr);\n  gap: ",
        "px;\n\n  div:nth-of-type(1) {\n    grid-row: 1 / 4;\n  }\n\n  div:nth-of-type(2) {\n    grid-column: 2 / 3;\n    grid-row: 1 / 2;\n  }\n\n  div:nth-of-type(3) {\n    grid-column: 2 / 4;\n    grid-row: 2 / 3;\n  }\n\n  div:nth-of-type(4) {\n    grid-column: 2 / 3;\n    grid-row: 3 / 4;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}




var storySkeletonCSS = (0,_emotion_react__WEBPACK_IMPORTED_MODULE_2__.css)(_templateObject(), chatie_design_system__WEBPACK_IMPORTED_MODULE_0__/* .Spacing.small */ .Ki.small, chatie_design_system__WEBPACK_IMPORTED_MODULE_0__/* .Spacing.medium */ .Ki.medium, chatie_design_system__WEBPACK_IMPORTED_MODULE_0__/* .Spacing.medium */ .Ki.medium);
var StorySkeleton = function() {
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)("div", {
        css: storySkeletonCSS,
        children: [
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_Frame__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {}),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_Frame__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {}),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_Frame__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {}),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_Frame__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {})
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (StorySkeleton);


/***/ }),

/***/ 1028:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "DE": function() { return /* binding */ RRStoryCard; },
  "di": function() { return /* binding */ RSStoryCard; },
  "FW": function() { return /* binding */ SRStoryCard; },
  "Ey": function() { return /* binding */ StoryCard; },
  "nH": function() { return /* binding */ StoryTag; },
  "ZP": function() { return /* binding */ stories_Story; },
  "V4": function() { return /* binding */ storyActionCSS; },
  "rr": function() { return /* binding */ storyWrapCSS; }
});

// UNUSED EXPORTS: coverImageCSS

// EXTERNAL MODULE: ./.yarn/__virtual__/@emotion-react-virtual-7a26ef4a22/0/cache/@emotion-react-npm-11.11.1-a07d6a6ebd-aec3c36650.zip/node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(8683);
// EXTERNAL MODULE: ./.yarn/__virtual__/@emotion-react-virtual-7a26ef4a22/0/cache/@emotion-react-npm-11.11.1-a07d6a6ebd-aec3c36650.zip/node_modules/@emotion/react/dist/emotion-react.browser.esm.js
var emotion_react_browser_esm = __webpack_require__(11717);
// EXTERNAL MODULE: ./.yarn/__virtual__/@emotion-react-virtual-7a26ef4a22/0/cache/@emotion-react-npm-11.11.1-a07d6a6ebd-aec3c36650.zip/node_modules/@emotion/react/dist/emotion-element-c39617d8.browser.esm.js + 2 modules
var emotion_element_c39617d8_browser_esm = __webpack_require__(71618);
// EXTERNAL MODULE: ./.yarn/__virtual__/next-i18next-virtual-9e5d267e7d/0/cache/next-i18next-npm-12.1.0-68b3291791-8c0e2f9764.zip/node_modules/next-i18next/dist/esm/index.js + 43 modules
var esm = __webpack_require__(26950);
// EXTERNAL MODULE: ./.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/index.js
var react = __webpack_require__(39953);
// EXTERNAL MODULE: ./hooks/useFirebase.ts + 1 modules
var useFirebase = __webpack_require__(37666);
// EXTERNAL MODULE: ./.yarn/__virtual__/chatie-design-system-virtual-6d39449242/0/cache/chatie-design-system-https-edc3b42f07-dc9424d6a3.zip/node_modules/chatie-design-system/dist/esm/index.js + 10 modules
var dist_esm = __webpack_require__(9150);
// EXTERNAL MODULE: ./.yarn/__virtual__/chatie-design-system-virtual-6d39449242/0/cache/chatie-design-system-https-edc3b42f07-dc9424d6a3.zip/node_modules/chatie-design-system/dist/esm/components/icon/index.js
var icon = __webpack_require__(82740);
// EXTERNAL MODULE: ./components/common/SvgIcon.tsx
var SvgIcon = __webpack_require__(34368);
;// CONCATENATED MODULE: ./public/icons/ic_lock.svg
var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgIcLock = function SvgIcLock(props) {
  return /*#__PURE__*/react.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/react.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.667,
    d: "M10.333 13.333H7.667A2.667 2.667 0 0 0 5 16v9.333A2.667 2.667 0 0 0 7.667 28h16a2.667 2.667 0 0 0 2.666-2.667V16a2.667 2.667 0 0 0-2.666-2.667H21m-10.667 0v-4a5.333 5.333 0 1 1 10.667 0v4m-10.667 0H21m-5.333 5.334v4"
  })));
};
/* harmony default export */ var ic_lock = (SvgIcLock);
;// CONCATENATED MODULE: ./public/images/partnership/honor/story_badge.png
/* harmony default export */ var story_badge = ({"src":"https://mn.chatie.me/assets/7d9981642c43abd8cd0848ba100b2edb8993cde5/_next/static/media/story_badge.4efcb631.png","height":48,"width":165,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAMAAABSSm3fAAAAG1BMVEVm0e9Yu+5avO8t3uY84OhO2et04e+D1/J60vGVDSr4AAAABXRSTlP+7/b4/GJUYwMAAAAJcEhZcwAAITgAACE4AUWWMWAAAAAaSURBVAiZY2BhY2Nj52BnYmBmZWVlYOBgBAADAwBKXzQjuAAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":2});
// EXTERNAL MODULE: ./pages/library.tsx + 8 modules
var library = __webpack_require__(86572);
// EXTERNAL MODULE: ./constants/index.ts
var constants = __webpack_require__(39854);
// EXTERNAL MODULE: ./styles/css.tsx
var css = __webpack_require__(96964);
// EXTERNAL MODULE: ./utils/date.ts + 31 modules
var date = __webpack_require__(9987);
// EXTERNAL MODULE: ./utils/misc.ts + 1 modules
var misc = __webpack_require__(45874);
// EXTERNAL MODULE: ./components/common/Avatar.tsx
var Avatar = __webpack_require__(81649);
// EXTERNAL MODULE: ./components/common/Badge.tsx
var Badge = __webpack_require__(63732);
// EXTERNAL MODULE: ./components/common/EFinderImage.tsx
var EFinderImage = __webpack_require__(11247);
// EXTERNAL MODULE: ./components/common/Image.tsx
var Image = __webpack_require__(85496);
// EXTERNAL MODULE: ./components/user/Nickname.tsx
var Nickname = __webpack_require__(87682);
;// CONCATENATED MODULE: ./components/stories/Story.tsx
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  position: absolute;\n  top: 0;\n  left: 0;\n  z-index: 2;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n      padding: 2px 3px;\n      color: ",
        ";\n      font-size: 10px;\n      background-color: ",
        ";\n      border-radius: 3px;\n    "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  position: relative;\n  display: flex;\n  align-items: center;\n  padding: ",
        "px ",
        "px;\n  cursor: pointer;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n  position: relative;\n  display: flex;\n  align-items: center;\n  padding: ",
        "px ",
        "px 0px;\n  cursor: pointer;\n  min-width: 0;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n  position: relative;\n  display: flex;\n  align-items: center;\n  max-width: calc(100% - 36px);\n  border-radius: 3px;\n  border: 1px solid ",
        ";\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n    width: 72px;\n    height: 54px;\n    border-radius: ",
        "px;\n  "
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _taggedTemplateLiteral([
        "\n    width: 98px;\n    height: 72px;\n    border-radius: ",
        "px;\n  "
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _taggedTemplateLiteral([
        "\n    width: 98px;\n    height: 72px;\n    border-radius: ",
        "px;\n  "
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = _taggedTemplateLiteral([
        "\n      position: relative;\n      width: 98px;\n      height: 72px;\n      ",
        "\n      border: 1px solid ",
        ";\n      overflow: hidden;\n      flex-shrink: 0;\n\n      .inactive {\n        display: flex;\n        flex-direction: column;\n        justify-content: center;\n        align-items: center;\n        position: absolute;\n        width: 98px;\n        height: 72px;\n        ",
        "\n        background-color: rgba(0, 0, 0, 0.5);\n        z-index: 1;\n        overflow: hidden;\n        color: ",
        ";\n        ",
        ";\n      }\n    "
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = _taggedTemplateLiteral([
        "\n  position: relative;\n  height: 72px;\n  margin-left: ",
        "px;\n  overflow: hidden;\n  flex-grow: 1;\n\n  h6 {\n    span + span {\n      margin-left: ",
        "px;\n    }\n  }\n\n  p {\n    margin-top: ",
        "px;\n    font-size: ",
        "px;\n    color: ",
        ";\n  }\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = _taggedTemplateLiteral([
        "\n  position: relative;\n  height: 56px;\n  overflow: hidden;\n  flex-grow: 1;\n  min-width: 0;\n\n  ",
        " {\n    height: auto;\n    min-height: 72px;\n  }\n\n  h6 {\n    color: ",
        ";\n    font-size: 14px;\n    font-style: normal;\n    font-weight: 600;\n    line-height: normal;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n  }\n\n  .description {\n    margin-top: 2px;\n    ",
        ";\n    color: ",
        ";\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n\n    ",
        " {\n      white-space: normal;\n      display: -webkit-box;\n      -webkit-line-clamp: 2;\n      -webkit-box-orient: vertical;\n    }\n  }\n  .info {\n    ",
        ";\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    margin-top: 2px;\n  }\n  .tapCount {\n    color: ",
        ";\n    font-weight: 600;\n    line-height: normal;\n  }\n  .nickname {\n    margin-left: ",
        "px;\n    color: ",
        ";\n    font-weight: 400;\n  }\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = _taggedTemplateLiteral([
        "\n  position: relative;\n  padding: 11px ",
        "px;\n  width: calc(100vw - 118px);\n  flex-grow: 1;\n  height: 90px;\n\n  .title {\n    color: ",
        ";\n    font-size: 12px;\n    font-style: normal;\n    font-weight: 500;\n    line-height: normal;\n    display: flex;\n    align-items: center;\n    width: calc(100vw - 118px - 52px);\n  }\n\n  .nickname {\n    display: flex;\n    align-items: center;\n    font-size: 11px;\n    margin-top: 4px !important;\n    width: calc(100vw - 118px - 64px);\n    overflow: hidden; /* 추가 */\n    text-overflow: ellipsis; /* 추가 */\n    white-space: nowrap; /* 줄 바꿈 방지 */\n  }\n  .label {\n    margin-right: 3px;\n    height: 15px;\n    span {\n      display: block !important;\n      width: 21px;\n      height: 15px;\n      font-size: 8px;\n      text-align: center;\n    }\n  }\n\n  h6 {\n    display: flex;\n    vertical-align: middle;\n    height: 15px;\n    align-text: center;\n    text-align: center;\n    align-items: center;\n    width: calc(100vw - 118px - 52px);\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n  }\n\n  p {\n    margin-top: 4px;\n    font-size: ",
        "px;\n    color: ",
        ";\n    font-family: 'Apple SD Gothic Neo';\n    font-size: 12px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 16px; /* 133.333% */\n  }\n\n  .description {\n    margin-top: 4px;\n    font-size: 11px;\n    width: calc(100vw - 118px - 52px);\n    color: ",
        ";\n    font-family: 'Apple SD Gothic Neo';\n    font-style: normal;\n    font-weight: 400;\n    line-height: 16px;\n    max-height: 32px;\n    min-height: 32px;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    display: -webkit-box;\n    -webkit-line-clamp: 2;\n    -webkit-box-orient: vertical;\n    word-break: break-all;\n  }\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: center;\n  position: absolute;\n  left: 0;\n  bottom: 4px;\n  font-size: ",
        "px;\n  color: ",
        ";\n\n  > span {\n    margin-left: ",
        "px;\n  }\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = _taggedTemplateLiteral([
        "\n  position: absolute;\n  right: 0;\n  bottom: 2px;\n  font-size: ",
        "px;\n  color: ",
        ";\n"
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = _taggedTemplateLiteral([
        "\n  width: 28px;\n  flex-shrink: 0;\n  margin-left: ",
        "px;\n  text-align: center;\n  color: ",
        ";\n"
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = _taggedTemplateLiteral([
        "\n  width: 32px;\n  flex-shrink: 0;\n  text-align: center;\n  color: ",
        ";\n  display: flex;\n  algin-items: center;\n  justify-content: center;\n\n  .label {\n    span {\n      display: block !important;\n      width: 23px;\n      height: 16px;\n      font-size: 8px;\n      text-align: center;\n    }\n  }\n"
    ]);
    _templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function _templateObject16() {
    var data = _taggedTemplateLiteral([
        "\n  position: relative;\n"
    ]);
    _templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}
function _templateObject17() {
    var data = _taggedTemplateLiteral([
        "\n  top: 0;\n  right: 0;\n  padding-top: ",
        "px;\n  padding-right: ",
        "px;\n"
    ]);
    _templateObject17 = function _templateObject17() {
        return data;
    };
    return data;
}
function _templateObject18() {
    var data = _taggedTemplateLiteral([
        "\n  display: inline-block;\n  width: 72px;\n\n  p {\n    margin-top: ",
        "px;\n    font-size: ",
        "px;\n  }\n"
    ]);
    _templateObject18 = function _templateObject18() {
        return data;
    };
    return data;
}
function _templateObject19() {
    var data = _taggedTemplateLiteral([
        "\n  position: absolute;\n  bottom: 5px;\n  padding: 0px 8px;\n  width: 100%;\n  text-overflow: hidden;\n  z-index: 9;\n  color: white;\n"
    ]);
    _templateObject19 = function _templateObject19() {
        return data;
    };
    return data;
}
function _templateObject20() {
    var data = _taggedTemplateLiteral([
        "\n  position: absolute;\n  top: 0;\n  width: 20px;\n  height: 20px;\n  text-align: center;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  background-color: ",
        ";\n  z-index: 9;\n  color: white;\n"
    ]);
    _templateObject20 = function _templateObject20() {
        return data;
    };
    return data;
}
function _templateObject21() {
    var data = _taggedTemplateLiteral([
        "\n  width: 100%;\n  height: 100%;\n  p {\n    font-size: ",
        "px;\n  }\n\n  .badge-container {\n    z-index: 2;\n  }\n"
    ]);
    _templateObject21 = function _templateObject21() {
        return data;
    };
    return data;
}
function _templateObject22() {
    var data = _taggedTemplateLiteral([
        "\n    position: relative;\n    width: 100%;\n    height: 100%;\n    border: 1px solid ",
        ";\n    border-radius: 3px;\n\n    overflow: hidden;\n    flex-shrink: 0;\n  "
    ]);
    _templateObject22 = function _templateObject22() {
        return data;
    };
    return data;
}
function _templateObject23() {
    var data = _taggedTemplateLiteral([
        "\n    position: relative;\n    width: 120px;\n    height: 90px;\n    border: 1px solid ",
        ";\n    border-radius: 3px 0px 0px 3px;\n\n    overflow: hidden;\n    flex-shrink: 0;\n  "
    ]);
    _templateObject23 = function _templateObject23() {
        return data;
    };
    return data;
}
function _templateObject24() {
    var data = _taggedTemplateLiteral([
        "\n    position: relative;\n    width: 75px;\n    height: 56px;\n    border: 1px solid ",
        ";\n    border-radius: 3px;\n\n    overflow: hidden;\n    flex-shrink: 0;\n\n    ",
        " {\n      width: 98px;\n      height: 72px;\n    }\n  "
    ]);
    _templateObject24 = function _templateObject24() {
        return data;
    };
    return data;
}
function _templateObject25() {
    var data = _taggedTemplateLiteral([
        "\n  position: absolute;\n  display: flex;\n  align-items: center;\n  width: 100%;\n  height: 100%;\n  justify-content: center;\n  z-index: 10;\n  opacity: 0.3;\n  background-color: black;\n"
    ]);
    _templateObject25 = function _templateObject25() {
        return data;
    };
    return data;
}
function _templateObject26() {
    var data = _taggedTemplateLiteral([
        "\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  z-index: 11;\n  color: white;\n\n  p {\n    margin-top: 3px;\n  }\n"
    ]);
    _templateObject26 = function _templateObject26() {
        return data;
    };
    return data;
}















var HIDDEN_STATS_STORY_IDS = [
    9817116,
    9817120,
    9817119,
    9817121
];





var tagCSS = (0,emotion_react_browser_esm.css)(_templateObject());
var customTagCSS = function(type) {
    return function(theme) {
        return (0,emotion_react_browser_esm.css)(_templateObject1(), theme.true.white, type === "tap_novel" ? theme.service.violet : type === "waitfree" ? theme.colors.yellow500 : theme.colors.red500);
    };
};
var StoryTag = function(param) {
    var theme = param.theme, saleType = param.saleType, type = param.type, hasHonorPartnership = param.hasHonorPartnership;
    var t = (0,esm/* useTranslation */.$G)().t;
    return hasHonorPartnership ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("div", {
        css: tagCSS,
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(Image/* default */.Z, {
            src: story_badge,
            width: 55,
            height: 16,
            alt: t("명예 작품")
        })
    }) : theme === constants/* StoryTheme.tapNovel */.xb.tapNovel ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("div", {
        css: [
            tagCSS,
            customTagCSS("tap_novel")
        ],
        children: t("탭소설")
    }) : saleType === constants/* StorySaleType.standardWaitfree */.dn.standardWaitfree ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("div", {
        css: [
            tagCSS,
            customTagCSS("waitfree")
        ],
        children: t("기다리면무료")
    }) : type === "original" ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("div", {
        css: [
            tagCSS,
            customTagCSS("original")
        ],
        children: t("오리지널")
    }) : null;
};
/**
 * Component
 */ var storyCSS = (0,emotion_react_browser_esm.css)(_templateObject2(), dist_esm/* Spacing.small */.Ki.small, dist_esm/* Spacing.medium */.Ki.medium);
var srStoryCSS = (0,emotion_react_browser_esm.css)(_templateObject3(), dist_esm/* Spacing.small */.Ki.small, dist_esm/* Spacing.medium */.Ki.medium);
var rsStoryCSS = function(theme) {
    return (0,emotion_react_browser_esm.css)(_templateObject4(), theme.border.lightest);
};
var _obj;
var CoverImageSize = (_obj = {}, _defineProperty(_obj, dist_esm/* Sizes.small */.u8.small, (0,emotion_react_browser_esm.css)(_templateObject5(), dist_esm/* Radius.xsmall */.wU.xsmall)), _defineProperty(_obj, dist_esm/* Sizes.medium */.u8.medium, (0,emotion_react_browser_esm.css)(_templateObject6(), dist_esm/* Radius.small */.wU.small)), _defineProperty(_obj, "library", (0,emotion_react_browser_esm.css)(_templateObject7(), dist_esm/* Radius.small */.wU.small)), _obj);
var coverImageCSS = function(size) {
    return function(theme) {
        return (0,emotion_react_browser_esm.css)(_templateObject8(), CoverImageSize[size], theme.border.lightest, CoverImageSize[size], theme.var.white, dist_esm/* Typography.body11 */.ZT.body11);
    };
};
var infoCSS = function(theme) {
    return (0,emotion_react_browser_esm.css)(_templateObject9(), dist_esm/* Spacing.xsmall */.Ki.xsmall, dist_esm/* Spacing.xxsmall */.Ki.xxsmall, dist_esm/* Spacing.xhsmall */.Ki.xhsmall, dist_esm/* FontSizes.xsmall */.TS.xsmall, theme.var.gray600);
};
var srInfoCSS = function(theme) {
    return (0,emotion_react_browser_esm.css)(_templateObject10(), css/* media.desktop */.BC.desktop, theme.var.black, dist_esm/* Typography.body12 */.ZT.body12, theme.var.gray600, css/* media.desktop */.BC.desktop, dist_esm/* Typography.body12 */.ZT.body12, theme.colors.main500, dist_esm/* Spacing.xsmall */.Ki.xsmall, theme.var.gray400);
};
var rsInfoCSS = function(theme) {
    return (0,emotion_react_browser_esm.css)(_templateObject11(), dist_esm/* Spacing.small */.Ki.small, theme.colors.main500, dist_esm/* FontSizes.xsmall */.TS.xsmall, theme.var.gray400, theme.var.gray400);
};
var userCSS = function(theme) {
    return (0,emotion_react_browser_esm.css)(_templateObject12(), dist_esm/* FontSizes.xsmall */.TS.xsmall, theme.var.gray500, dist_esm/* Spacing.xxsmall */.Ki.xxsmall);
};
var tapCSS = function(theme) {
    return (0,emotion_react_browser_esm.css)(_templateObject13(), dist_esm/* FontSizes.xsmall */.TS.xsmall, theme.var.gray500);
};
var rankCSS = function(theme) {
    return (0,emotion_react_browser_esm.css)(_templateObject14(), dist_esm/* Spacing.xsmall */.Ki.xsmall, theme.var.black);
};
var srRankCSS = function(theme) {
    return (0,emotion_react_browser_esm.css)(_templateObject15(), theme.var.black);
};
var Story = function(_param) {
    var rank = _param.rank, label = _param.label, onClick = _param.onClick, isLibrary = _param.isLibrary, isMyPage = _param.isMyPage, _isInflow = _param.isInflow, isInflow = _isInflow === void 0 ? true : _isInflow, _isActive = _param.isActive, isActive = _isActive === void 0 ? true : _isActive, story = _objectWithoutProperties(_param, [
        "rank",
        "label",
        "onClick",
        "isLibrary",
        "isMyPage",
        "isInflow",
        "isActive"
    ]);
    var id = story.id, title = story.title, coverImage = story.coverImage, summary = story.summary, user = story.user, tapCount = story.tapCount, hasNewEpisode = story.hasNewEpisode, firstEpisodePublished = story.firstEpisodePublished;
    var t = (0,esm/* useTranslation */.$G)().t;
    var theme = (0,emotion_element_c39617d8_browser_esm.u)();
    var inflow = (0,useFirebase/* useFirebase */.f)().inflow;
    var ref = (0,Badge/* useBadgePresets */.fw)(), yellow = ref.yellow, red = ref.red;
    var handleClick = function(e) {
        if (isInflow) {
            inflow(id);
        }
        onClick === null || onClick === void 0 ? void 0 : onClick(e);
    };
    var renderLabels = (0,react.useCallback)(function() {
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)(emotion_react_jsx_runtime_browser_esm.Fragment, {
            children: [
                hasNewEpisode && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(Badge/* default */.ZP, _objectSpread({
                    text: "UP"
                }, yellow)),
                firstEpisodePublished && (0,date/* differenceInDays */.jc)(new Date(), firstEpisodePublished) < 2 && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(Badge/* default */.ZP, _objectSpread({
                    text: "NEW"
                }, red))
            ]
        });
    }, [
        hasNewEpisode,
        firstEpisodePublished
    ]);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)("article", {
        css: storyCSS,
        "data-id": id,
        onClick: handleClick,
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)("div", {
                css: coverImageCSS(isLibrary ? library.LIBRARY_SIZE : dist_esm/* Sizes.medium */.u8.medium),
                children: [
                    isMyPage && !isActive && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)("div", {
                        className: "inactive",
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(SvgIcon/* default */.Z, {
                                icon: ic_lock,
                                d: 24
                            }),
                            "비공개"
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(StoryTag, _objectSpread({}, story)),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(EFinderImage/* default */.ZP, {
                        image: coverImage,
                        h: 96
                    })
                ]
            }),
            rank && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("div", {
                css: rankCSS,
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("h6", {
                    children: rank
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)("div", {
                css: infoCSS,
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)("h6", {
                        className: "ellipsis align-middle",
                        children: [
                            renderLabels(),
                            label,
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("span", {
                                children: title
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("p", {
                        className: "ellipsis",
                        children: summary
                    }),
                    user ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)("div", {
                        css: userCSS,
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(Avatar/* default */.ZP, _objectSpread({
                                size: Avatar/* AvatarSize.xsmall */.DZ.xsmall
                            }, user)),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(Nickname/* default */.Z, _objectSpread({}, user))
                        ]
                    }) : null,
                    tapCount !== undefined && !HIDDEN_STATS_STORY_IDS.includes(id) && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)("div", {
                        css: tapCSS,
                        className: "icon-text",
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(icon/* Icon */.JO, {
                                icon: icon/* Tap */.Uw,
                                color: theme.var.gray500,
                                size: dist_esm/* Sizes.small */.u8.small
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("span", {
                                children: t("simplifyNumber", {
                                    val: tapCount !== null && tapCount !== void 0 ? tapCount : 0
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var stories_Story = (Story);
/**
 * Other view types
 */ var storyWrapCSS = (0,emotion_react_browser_esm.css)(_templateObject16());
var storyActionCSS = (0,emotion_react_browser_esm.css)(_templateObject17(), dist_esm/* Spacing.small */.Ki.small, dist_esm/* Spacing.small */.Ki.small);
var storyCardCSS = (0,emotion_react_browser_esm.css)(_templateObject18(), dist_esm/* Spacing.xxsmall */.Ki.xxsmall, dist_esm/* FontSizes.xsmall */.TS.xsmall);
var StoryCard = function(_param) {
    var onClick = _param.onClick, _isInflow = _param.isInflow, isInflow = _isInflow === void 0 ? true : _isInflow, story = _objectWithoutProperties(_param, [
        "onClick",
        "isInflow"
    ]);
    var id = story.id, coverImage = story.coverImage, title = story.title;
    var inflow = (0,useFirebase/* useFirebase */.f)().inflow;
    var handleClick = function(e) {
        if (isInflow) {
            inflow(id);
        }
        onClick === null || onClick === void 0 ? void 0 : onClick(e);
    };
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)("article", {
        css: storyCardCSS,
        onClick: handleClick,
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)("div", {
                css: coverImageCSS(dist_esm/* Sizes.small */.u8.small),
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(StoryTag, _objectSpread({}, story)),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(EFinderImage/* default */.ZP, {
                        image: coverImage,
                        h: 54
                    })
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("p", {
                className: "ellipsis",
                children: title
            })
        ]
    });
};
var rrTitleCSS = (0,emotion_react_browser_esm.css)(_templateObject19());
var rrRankCSS = function(theme) {
    return (0,emotion_react_browser_esm.css)(_templateObject20(), theme.colors.main500);
};
var rrStoryCardCSS = (0,emotion_react_browser_esm.css)(_templateObject21(), dist_esm/* FontSizes.xsmall */.TS.xsmall);
var rrCoverImageCSS = function(theme) {
    return (0,emotion_react_browser_esm.css)(_templateObject22(), theme.border.lightest);
};
var rsCoverImageCSS = function(theme) {
    return (0,emotion_react_browser_esm.css)(_templateObject23(), theme.border.lightest);
};
var srCoverImageCSS = function(theme) {
    return (0,emotion_react_browser_esm.css)(_templateObject24(), theme.border.lightest, css/* media.desktop */.BC.desktop);
};
var overalyCSS = (0,emotion_react_browser_esm.css)(_templateObject25());
var moreCSS = (0,emotion_react_browser_esm.css)(_templateObject26());
var RRStoryCard = function(_param) {
    var onClick = _param.onClick, _isInflow = _param.isInflow, isInflow = _isInflow === void 0 ? true : _isInflow, rank = _param.rank, overlay = _param.overlay, isAd = _param.isAd, badgePreset = _param.badgePreset, story = _objectWithoutProperties(_param, [
        "onClick",
        "isInflow",
        "rank",
        "overlay",
        "isAd",
        "badgePreset"
    ]);
    var id = story.id, coverImage = story.coverImage, title = story.title;
    var inflow = (0,useFirebase/* useFirebase */.f)().inflow;
    var t = (0,esm/* useTranslation */.$G)().t;
    var handleClick = function(e) {
        if (isInflow) {
            inflow(id);
        }
        onClick === null || onClick === void 0 ? void 0 : onClick(e);
    };
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("article", {
        css: rrStoryCardCSS,
        onClick: handleClick,
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)("div", {
            css: rrCoverImageCSS,
            children: [
                rank && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("p", {
                    css: rrRankCSS,
                    children: rank
                }),
                isAd && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("div", {
                    className: "badge-container",
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(Badge/* default */.ZP, _objectSpreadProps(_objectSpread({
                        text: t("홍보")
                    }, badgePreset), {
                        className: "rank"
                    }))
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(EFinderImage/* OptimizeEFinderImage */.yK, {
                    image: coverImage,
                    h: 54,
                    layout: "fill"
                }),
                overlay && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)("div", {
                    css: moreCSS,
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)("svg", {
                            width: "32",
                            height: "32",
                            viewBox: "0 0 32 32",
                            fill: "none",
                            xmlns: "http://www.w3.org/2000/svg",
                            children: [
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("circle", {
                                    cx: "16",
                                    cy: "16",
                                    r: "15.5",
                                    stroke: "white"
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("path", {
                                    d: "M16.5 10V22",
                                    stroke: "white",
                                    strokeLinecap: "round",
                                    strokeLinejoin: "round"
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("path", {
                                    d: "M22.5 16L10.5 16",
                                    stroke: "white",
                                    strokeLinecap: "round",
                                    strokeLinejoin: "round"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("p", {
                            children: t("더보기")
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("div", {
                            css: overalyCSS
                        })
                    ]
                }),
                !isAd && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(StoryTag, _objectSpread({}, story)),
                !overlay && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("p", {
                    className: "ellipsis",
                    css: rrTitleCSS,
                    children: title
                })
            ]
        })
    });
};
var RSStoryCard = function(_param) {
    var label = _param.label, onClick = _param.onClick, _isInflow = _param.isInflow, isInflow = _isInflow === void 0 ? true : _isInflow, story = _objectWithoutProperties(_param, [
        "label",
        "onClick",
        "isInflow"
    ]);
    var id = story.id, title = story.title, coverImage = story.coverImage, summary = story.summary, user = story.user;
    var ellipsisedTitle = (title === null || title === void 0 ? void 0 : title.length) > 22 ? title.slice(0, 22) + "..." : title;
    var inflow = (0,useFirebase/* useFirebase */.f)().inflow;
    var handleClick = function(e) {
        if (isInflow) {
            inflow(id);
        }
        onClick === null || onClick === void 0 ? void 0 : onClick(e);
    };
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)("article", {
        css: rsStoryCSS,
        "data-id": id,
        onClick: handleClick,
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)("div", {
                css: rsCoverImageCSS,
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(StoryTag, _objectSpread({}, story)),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(EFinderImage/* OptimizeEFinderImage */.yK, {
                        image: coverImage,
                        h: 96
                    })
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)("div", {
                css: rsInfoCSS,
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)("h6", {
                        className: "ellipsis align-middle",
                        children: [
                            !!label && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("span", {
                                className: "label",
                                children: label
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("span", {
                                className: "title",
                                children: ellipsisedTitle
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("p", {
                        className: "description ",
                        children: summary
                    }),
                    !!user && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("p", {
                        className: "ellipsis nickname",
                        children: "by " + user.nickname
                    })
                ]
            })
        ]
    });
};
var SRStoryCard = function(_param) {
    var rank = _param.rank, label = _param.label, onClick = _param.onClick, _isInflow = _param.isInflow, isInflow = _isInflow === void 0 ? true : _isInflow, story = _objectWithoutProperties(_param, [
        "rank",
        "label",
        "onClick",
        "isInflow"
    ]);
    var id = story.id, title = story.title, coverImage = story.coverImage, summary = story.summary, user = story.user, tapCount = story.tapCount;
    var tapNumber = (0,misc/* simplifyNumber */.Qh)({
        value: tapCount !== null && tapCount !== void 0 ? tapCount : 0
    });
    var t = (0,esm/* useTranslation */.$G)().t;
    var inflow = (0,useFirebase/* useFirebase */.f)().inflow;
    var handleClick = function(e) {
        if (isInflow) {
            inflow(id);
        }
        onClick === null || onClick === void 0 ? void 0 : onClick(e);
    };
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)("article", {
        css: srStoryCSS,
        "data-id": id,
        onClick: handleClick,
        suppressHydrationWarning: true,
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)("div", {
                css: srCoverImageCSS,
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(StoryTag, _objectSpread({}, story)),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(EFinderImage/* OptimizeEFinderImage */.yK, {
                        image: coverImage,
                        h: 96
                    })
                ]
            }),
            rank && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("div", {
                css: srRankCSS,
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("h6", {
                    children: rank
                })
            }),
            label && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("div", {
                css: srRankCSS,
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("div", {
                    className: "label",
                    children: label
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)("div", {
                css: srInfoCSS,
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("h6", {
                        className: "ellipsis align-middle title",
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("span", {
                            children: title
                        })
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("p", {
                        className: "ellipsis description",
                        children: summary
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)("p", {
                        className: "info",
                        children: [
                            !!tapCount && !HIDDEN_STATS_STORY_IDS.includes(id) && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("span", {
                                className: "tapCount",
                                children: t(tapNumber)
                            }),
                            !!user && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("span", {
                                className: "ellipsis nickname",
                                children: "by " + user.nickname
                            })
                        ]
                    })
                ]
            })
        ]
    });
};


/***/ }),

/***/ 6330:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "c": function() { return /* binding */ useStoryQuery; }
/* harmony export */ });
/* harmony import */ var react_query__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(54909);
/* harmony import */ var date_fns_minutesToMilliseconds__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(72218);
/* harmony import */ var _api_story__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(10741);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(39854);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}




var useStoryQuery = function() {
    var useFetchStory = function(storyId, options) {
        var queryKey = _constants__WEBPACK_IMPORTED_MODULE_2__/* .QUERY_KEYS.STORY.ONE */ .U7.STORY.ONE(storyId);
        var query = (0,react_query__WEBPACK_IMPORTED_MODULE_0__.useQuery)(queryKey, function() {
            return (0,_api_story__WEBPACK_IMPORTED_MODULE_1__/* .fetchStory */ .su)(storyId);
        }, _objectSpread({
            staleTime: (0,date_fns_minutesToMilliseconds__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(15),
            cacheTime: (0,date_fns_minutesToMilliseconds__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(15)
        }, options));
        return query;
    };
    var useFetchMyStory = function(storyId) {
        var query = (0,react_query__WEBPACK_IMPORTED_MODULE_0__.useQuery)(_constants__WEBPACK_IMPORTED_MODULE_2__/* .QUERY_KEYS.MY_STORY.STORY */ .U7.MY_STORY.STORY(storyId), function() {
            return (0,_api_story__WEBPACK_IMPORTED_MODULE_1__/* .fetchMyStory */ .mI)(storyId);
        });
        return query;
    };
    var useFetchLatestStory = function() {
        return (0,react_query__WEBPACK_IMPORTED_MODULE_0__.useQuery)("myLatestStory", function() {
            return (0,_api_story__WEBPACK_IMPORTED_MODULE_1__/* .fetchMyLatestStory */ .zA)();
        }, {
            suspense: false
        });
    };
    var ref = (0,react_query__WEBPACK_IMPORTED_MODULE_0__.useMutation)(function(storyIds) {
        return (0,_api_story__WEBPACK_IMPORTED_MODULE_1__/* .deleteReadStories */ .qR)(storyIds);
    }), removeReadStories = ref.mutate;
    var useFetchStoryIknow = function(storyId, options) {
        var queryKey = _constants__WEBPACK_IMPORTED_MODULE_2__/* .QUERY_KEYS.STORY.ONE */ .U7.STORY.ONE(storyId);
        var query = (0,react_query__WEBPACK_IMPORTED_MODULE_0__.useQuery)(queryKey, function() {
            return (0,_api_story__WEBPACK_IMPORTED_MODULE_1__/* .fetchStoryIknow */ .yb)(storyId);
        }, _objectSpread({
            staleTime: (0,date_fns_minutesToMilliseconds__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(15),
            cacheTime: (0,date_fns_minutesToMilliseconds__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(15)
        }, options));
        return query;
    };
    var useReadEvent = function(code) {
        var queryKey = _constants__WEBPACK_IMPORTED_MODULE_2__/* .QUERY_KEYS.STORY.READ_EVENT */ .U7.STORY.READ_EVENT(code);
        var query = (0,react_query__WEBPACK_IMPORTED_MODULE_0__.useQuery)(queryKey, function() {
            return (0,_api_story__WEBPACK_IMPORTED_MODULE_1__/* .getReadEvent */ .GX)(code);
        }, {
            staleTime: (0,date_fns_minutesToMilliseconds__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(15),
            cacheTime: (0,date_fns_minutesToMilliseconds__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(15)
        });
        return query;
    };
    var usePublishChallengeInfo = function(storyId) {
        var queryKey = _constants__WEBPACK_IMPORTED_MODULE_2__/* .QUERY_KEYS.MY_STORY.PUBLISH_CHALLENGE_INFO */ .U7.MY_STORY.PUBLISH_CHALLENGE_INFO(storyId);
        var query = (0,react_query__WEBPACK_IMPORTED_MODULE_0__.useQuery)(queryKey, function() {
            return (0,_api_story__WEBPACK_IMPORTED_MODULE_1__/* .getPublishChallengeInfo */ .TA)(storyId);
        });
        return query;
    };
    var useWeeklySummary = function(storyId) {
        var queryKey = _constants__WEBPACK_IMPORTED_MODULE_2__/* .QUERY_KEYS.STORY.SUMMARIES */ .U7.STORY.SUMMARIES(storyId);
        var query = (0,react_query__WEBPACK_IMPORTED_MODULE_0__.useQuery)(queryKey, function() {
            return (0,_api_story__WEBPACK_IMPORTED_MODULE_1__/* .getWeeklySumamries */ .Gp)(storyId);
        });
        return query;
    };
    return {
        useFetchStory: useFetchStory,
        useFetchMyStory: useFetchMyStory,
        useFetchLatestStory: useFetchLatestStory,
        removeReadStories: removeReadStories,
        useFetchStoryIknow: useFetchStoryIknow,
        useReadEvent: useReadEvent,
        usePublishChallengeInfo: usePublishChallengeInfo,
        useWeeklySummary: useWeeklySummary
    };
};


/***/ }),

/***/ 86572:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "LIBRARY_SIZE": function() { return /* binding */ LIBRARY_SIZE; },
  "default": function() { return /* binding */ library; }
});

// EXTERNAL MODULE: ./.yarn/__virtual__/@emotion-react-virtual-7a26ef4a22/0/cache/@emotion-react-npm-11.11.1-a07d6a6ebd-aec3c36650.zip/node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(8683);
// EXTERNAL MODULE: ./.yarn/__virtual__/@emotion-react-virtual-7a26ef4a22/0/cache/@emotion-react-npm-11.11.1-a07d6a6ebd-aec3c36650.zip/node_modules/@emotion/react/dist/emotion-react.browser.esm.js
var emotion_react_browser_esm = __webpack_require__(11717);
// EXTERNAL MODULE: ./.yarn/__virtual__/next-i18next-virtual-9e5d267e7d/0/cache/next-i18next-npm-12.1.0-68b3291791-8c0e2f9764.zip/node_modules/next-i18next/dist/esm/index.js + 43 modules
var esm = __webpack_require__(26950);
// EXTERNAL MODULE: ./.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/index.js
var react = __webpack_require__(39953);
// EXTERNAL MODULE: ./.yarn/__virtual__/react-query-virtual-8f3bd3534b/0/cache/react-query-npm-3.39.3-72b2a93edf-d2de6a0992.zip/node_modules/react-query/es/index.js
var es = __webpack_require__(54909);
// EXTERNAL MODULE: ./hooks/query/useStoryQuery.ts
var useStoryQuery = __webpack_require__(6330);
// EXTERNAL MODULE: ./stores/useReadStoryStore.ts
var useReadStoryStore = __webpack_require__(83472);
// EXTERNAL MODULE: ./.yarn/__virtual__/zustand-virtual-1c6fdf1cb3/0/cache/zustand-npm-4.4.7-974264f8cd-9aeb6cc861.zip/node_modules/zustand/esm/index.mjs + 1 modules
var zustand_esm = __webpack_require__(88766);
;// CONCATENATED MODULE: ./stores/useVpDiffStore.ts
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}

var useVpDiffStore = (0,zustand_esm/* create */.Ue)(function(set, get) {
    return {
        diff: 0,
        getDiff: function() {
            var diff = get().diff;
            return diff;
        },
        setDiff: function(diff) {
            set(function(state) {
                return _objectSpreadProps(_objectSpread({}, state), {
                    diff: diff
                });
            });
        }
    };
});
/* harmony default export */ var stores_useVpDiffStore = (useVpDiffStore);

// EXTERNAL MODULE: ./.yarn/__virtual__/chatie-design-system-virtual-6d39449242/0/cache/chatie-design-system-https-edc3b42f07-dc9424d6a3.zip/node_modules/chatie-design-system/dist/esm/index.js + 10 modules
var dist_esm = __webpack_require__(9150);
// EXTERNAL MODULE: ./components/chat/ChatRoomList.tsx + 1 modules
var ChatRoomList = __webpack_require__(15589);
// EXTERNAL MODULE: ./components/common/BottomButton.tsx
var BottomButton = __webpack_require__(1035);
// EXTERNAL MODULE: ./components/common/HorizontalFilter.tsx
var HorizontalFilter = __webpack_require__(61507);
// EXTERNAL MODULE: ./components/common/Loading.tsx
var Loading = __webpack_require__(30208);
// EXTERNAL MODULE: ./components/common/Seo.tsx
var Seo = __webpack_require__(14054);
// EXTERNAL MODULE: ./components/common/Tab.tsx
var Tab = __webpack_require__(93127);
// EXTERNAL MODULE: ./components/layout/Header.tsx + 1 modules
var Header = __webpack_require__(58761);
// EXTERNAL MODULE: ./components/layout/Layout.tsx
var Layout = __webpack_require__(26382);
// EXTERNAL MODULE: ./components/layout/Push.tsx
var Push = __webpack_require__(23516);
// EXTERNAL MODULE: ./components/layout/SafeArea.tsx
var SafeArea = __webpack_require__(45861);
// EXTERNAL MODULE: ./components/skeleton/CharacterSkeleton.tsx
var CharacterSkeleton = __webpack_require__(48782);
// EXTERNAL MODULE: ./components/skeleton/SkeletonList.tsx
var SkeletonList = __webpack_require__(6668);
// EXTERNAL MODULE: ./components/skeleton/StorySkeleton.tsx
var StorySkeleton = __webpack_require__(21567);
// EXTERNAL MODULE: ./.yarn/__virtual__/next-virtual-9251101693/0/cache/next-npm-12.3.4-cdaf2db0a7-d96fc4f5bc.zip/node_modules/next/router.js
var next_router = __webpack_require__(47311);
// EXTERNAL MODULE: ./hooks/useScrollPosition.ts
var useScrollPosition = __webpack_require__(80786);
// EXTERNAL MODULE: ./components/common/Button.tsx
var Button = __webpack_require__(38945);
// EXTERNAL MODULE: ./components/common/RoundAvatar.tsx
var RoundAvatar = __webpack_require__(81794);
;// CONCATENATED MODULE: ./components/chat/EmptyChatRoom.tsx
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  padding: ",
        "px ",
        "px ",
        "px\n    ",
        "px;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n    display: flex;\n    flex-direction: row;\n    margin-left: ",
        "px;\n    width: 100%;\n    justify-content: space-between;\n    align-items: center;\n\n    h5 {\n      display: flex;\n      color: ",
        ";\n    }\n\n    p {\n      ",
        ";\n      color: ",
        ";\n      line-height: 135%;\n      margin-top: ",
        "px;\n    }\n  "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  top: 50%;\n  ",
        ";\n  padding: ",
        "px ",
        "px;\n  width: 62px;\n  height: 28px;\n  border-radius: ",
        "px;\n\n  p {\n    ",
        ";\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}






var chatRoomCSS = (0,emotion_react_browser_esm.css)(_templateObject(), dist_esm/* Spacing.small */.Ki.small, dist_esm/* Spacing.small */.Ki.small, dist_esm/* Spacing.small */.Ki.small, dist_esm/* Spacing.medium */.Ki.medium);
var chatRoomHeaderCSS = function(theme) {
    return (0,emotion_react_browser_esm.css)(_templateObject1(), dist_esm/* Spacing.medium */.Ki.medium, theme.var.black, dist_esm/* Typography.body12 */.ZT.body12, theme.var.gray500, dist_esm/* Spacing.xxsmall */.Ki.xxsmall);
};
var storySelecButtonCSS = (0,emotion_react_browser_esm.css)(_templateObject2(), dist_esm/* Typography.body12 */.ZT.body12, dist_esm/* Spacing.xsmall */.Ki.xsmall, dist_esm/* Spacing.xsmall */.Ki.xsmall, dist_esm/* Radius.small */.wU.small, dist_esm/* Typography.body12 */.ZT.body12);
var EmptyChatRoom = function(param) {
    var data = param.data, onClickAvatar = param.onClickAvatar, onClickEnter = param.onClickEnter, _buttonText = param.buttonText, buttonText = _buttonText === void 0 ? "입장하기" : _buttonText;
    var t = (0,esm/* useTranslation */.$G)().t;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)("article", {
        css: chatRoomCSS,
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("div", {
                onClick: onClickAvatar ? function() {
                    return onClickAvatar(data.id);
                } : undefined,
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(RoundAvatar/* default */.Z, {
                    size: 44,
                    picture: data === null || data === void 0 ? void 0 : data.image
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)("div", {
                css: chatRoomHeaderCSS,
                onClick: onClickEnter ? function() {
                    return onClickEnter(data);
                } : undefined,
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("h5", {
                                children: t("{{characterName}}", {
                                    characterName: data.characterName
                                })
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("p", {
                                children: t("{{lastMessage}}", {
                                    lastMessage: data.lastMessage
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(Button/* default */.Z, {
                        text: t(buttonText),
                        css: storySelecButtonCSS
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var chat_EmptyChatRoom = (EmptyChatRoom);

// EXTERNAL MODULE: ./components/common/Empty.tsx
var Empty = __webpack_require__(34270);
// EXTERNAL MODULE: ./components/common/ListItem.tsx
var ListItem = __webpack_require__(92626);
// EXTERNAL MODULE: ./components/common/NativeInFeedAd.tsx
var NativeInFeedAd = __webpack_require__(80521);
// EXTERNAL MODULE: ./components/common/Pagination.tsx
var Pagination = __webpack_require__(39753);
// EXTERNAL MODULE: ./stores/useLoadingStore.ts
var useLoadingStore = __webpack_require__(70182);
// EXTERNAL MODULE: ./components/common/ActionSheet.tsx
var ActionSheet = __webpack_require__(83898);
// EXTERNAL MODULE: ./components/stories/Story.tsx + 2 modules
var Story = __webpack_require__(1028);
// EXTERNAL MODULE: ./api/story.ts
var api_story = __webpack_require__(10741);
// EXTERNAL MODULE: ./utils/query.ts
var utils_query = __webpack_require__(96261);
// EXTERNAL MODULE: ./constants/index.ts
var constants = __webpack_require__(39854);
;// CONCATENATED MODULE: ./components/stories/LikedStory.tsx
function LikedStory_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function LikedStory_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            LikedStory_defineProperty(target, key, source[key]);
        });
    }
    return target;
}


// import { useRouter } from 'next/router';








var LikedStory = function(props) {
    var id = props.id;
    var t = (0,esm/* useTranslation */.$G)().t;
    var setLoading = (0,useLoadingStore/* useLoadingStore */.R)().setLoading;
    var optimistic = (0,utils_query/* useOptimisticUpdate */.p7)();
    var mutate = (0,es.useMutation)(function(id) {
        return (0,api_story/* unlikeStory */.lU)(id);
    }).mutate;
    var ref = (0,react.useState)([
        {
            label: t("삭제하기"),
            value: "unlike",
            isDanger: true
        }, 
    ]), actions = ref[0];
    var handleAction = (0,react.useCallback)(function(action) {
        if (action === "unlike") {
            setLoading(true);
            mutate(id, {
                onSuccess: function() {
                    optimistic.remove(constants/* QUERY_KEYS.LIKED_STORY.LIST */.U7.LIKED_STORY.LIST, id);
                },
                onSettled: function() {
                    return setLoading(false);
                }
            });
        }
    }, [
        id
    ]);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)("article", {
        css: Story/* storyWrapCSS */.rr,
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(Story/* default */.ZP, LikedStory_objectSpread({}, props)),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(ActionSheet/* KebabMenu */.f, {
                css: Story/* storyActionCSS */.V4,
                name: "liked-story-".concat(id),
                options: actions,
                onSelect: handleAction
            })
        ]
    });
};
/* harmony default export */ var stories_LikedStory = (LikedStory);

// EXTERNAL MODULE: ./api/chatbot.ts
var chatbot = __webpack_require__(23082);
// EXTERNAL MODULE: ./contexts/global.ts
var global = __webpack_require__(30259);
// EXTERNAL MODULE: ./styles/css.tsx
var css = __webpack_require__(96964);
// EXTERNAL MODULE: ./utils/analytics.ts
var analytics = __webpack_require__(3263);
// EXTERNAL MODULE: ./utils/misc.ts + 1 modules
var misc = __webpack_require__(45874);
// EXTERNAL MODULE: ./utils/webview.ts
var webview = __webpack_require__(81946);
;// CONCATENATED MODULE: ./components/stories/LikedStoryList.tsx
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function LikedStoryList_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function LikedStoryList_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            LikedStoryList_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function LikedStoryList_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
var __generator = undefined && undefined.__generator || function(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
function LikedStoryList_templateObject() {
    var data = LikedStoryList_taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: row;\n  text-align: left;\n  padding: ",
        "px ",
        "px;\n  border-bottom: 1px solid ",
        ";\n  ",
        ";\n  z-index: 3;\n  background-color: ",
        ";\n  height: 43px;\n  gap: ",
        "px;\n\n  &::after {\n    content: '';\n    display: table;\n    clear: both;\n  }\n"
    ]);
    LikedStoryList_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function LikedStoryList_templateObject1() {
    var data = LikedStoryList_taggedTemplateLiteral([
        "\n  margin-top: ",
        "px;\n"
    ]);
    LikedStoryList_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
























var filterCSS = function(theme) {
    return (0,emotion_react_browser_esm.css)(LikedStoryList_templateObject(), dist_esm/* Spacing.small */.Ki.small, dist_esm/* Spacing.medium */.Ki.medium, theme.border.light, (0,css/* sticky */.CA)(Push/* PushSize.tab */.z.tab), theme.var.white, dist_esm/* Spacing.xsmall */.Ki.xsmall);
};
var chatRoomListCss = (0,emotion_react_browser_esm.css)(LikedStoryList_templateObject1(), dist_esm/* Spacing.small */.Ki.small);
var LikedStoryList = function() {
    var ref;
    var t = (0,esm/* useTranslation */.$G)().t;
    var router = (0,next_router.useRouter)();
    var ref1 = (0,react.useState)("story"), activeType = ref1[0], setActiveType = ref1[1];
    var firebase = (0,analytics/* useAnalytics */.z)().firebase;
    var platform = (0,global/* useGlobalContext */.bN)().platform;
    var web = (0,webview/* useWebView */.B9)().web;
    var isChatbot = activeType === "chatbot";
    var isStory = activeType === "story";
    var query = (0,utils_query/* usePaginationQuery */.Zl)(constants/* QUERY_KEYS.LIKED_STORY.LIST */.U7.LIKED_STORY.LIST, function(param) {
        var pageParam = param.pageParam;
        return (0,api_story/* fetchLikedStories */.vT)(pageParam);
    });
    (0,useScrollPosition/* useScrollPosition */.R)("likedStoryList");
    var characterQueries = {
        only_like: true
    };
    var characterQueryKey = constants/* QUERY_KEYS.CHARACTER.LIKE_LIST */.U7.CHARACTER.LIKE_LIST();
    var characterQuery = (0,utils_query/* useChatPaginationQuery */.aI)(characterQueryKey, function() {
        var _ref = _asyncToGenerator(function(param) {
            var pageParam;
            return __generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        pageParam = param.pageParam;
                        return [
                            4,
                            (0,chatbot/* fetchCharacters */.Em)(characterQueries, pageParam)
                        ];
                    case 1:
                        return [
                            2,
                            _state.sent()
                        ];
                }
            });
        });
        return function(_) {
            return _ref.apply(this, arguments);
        };
    }(), {
        refetchOnWindowFocus: "always"
    });
    var handleClickMoveToIntro = function() {
        var _ref = _asyncToGenerator(function(item) {
            var ref, isOfficial, characterId, situations, ref1, ref2;
            return __generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        (0,misc/* setFlow */.kB)({
                            name: "대화하기"
                        });
                        isOfficial = (item === null || item === void 0 ? void 0 : item.type) === "official";
                        characterId = item.id;
                        firebase.logEvent("chatbot_click_library_like_chat", {
                            btn_type: "chat",
                            character_id: characterId
                        });
                        if (isOfficial) {
                            if (platform === constants/* Platform.web */.t4.web) {
                                return [
                                    2,
                                    router.push("/play/characters/".concat(characterId))
                                ];
                            } else {
                                return [
                                    2,
                                    web.openPage("/play/characters/".concat(characterId))
                                ];
                            }
                        }
                        return [
                            4,
                            (0,chatbot/* fetchSituations */.XZ)({
                                character_id: item.id
                            })
                        ];
                    case 1:
                        situations = _state.sent();
                        if (!(situations === null || situations === void 0 ? void 0 : (ref = situations.items) === null || ref === void 0 ? void 0 : ref.length)) {
                            if (platform === constants/* Platform.web */.t4.web) {
                                return [
                                    2,
                                    router.push("/play/characters/".concat(characterId))
                                ];
                            } else {
                                return [
                                    2,
                                    web.openPage("/play/characters/".concat(characterId))
                                ];
                            }
                        }
                        if (platform === constants/* Platform.web */.t4.web) {
                            ;
                            return [
                                2,
                                router.push("/play/situations/".concat((ref1 = situations === null || situations === void 0 ? void 0 : situations.items[0]) === null || ref1 === void 0 ? void 0 : ref1.id, "/chat-room"))
                            ];
                        } else {
                            ;
                            return [
                                2,
                                web.openPage("/play/situations/".concat((ref2 = situations === null || situations === void 0 ? void 0 : situations.items[0]) === null || ref2 === void 0 ? void 0 : ref2.id, "/chat-room"))
                            ];
                        }
                        return [
                            2
                        ];
                }
            });
        });
        return function handleClickMoveToIntro(item) {
            return _ref.apply(this, arguments);
        };
    }();
    var handleClickAvatar = function(characterId) {
        firebase.logEvent("chatbot_click_library_like_chat", {
            btn_type: "profile",
            character_id: characterId
        });
        if (platform === constants/* Platform.web */.t4.web) {
            return router.push("/play/characters/".concat(characterId));
        } else {
            return web.openPage("/play/characters/".concat(characterId));
        }
    };
    (0,react.useEffect)(function() {
        if (isChatbot) {
            (0,misc/* setFlow */.kB)({
                isDelete: true
            });
            (0,misc/* setFlow */.kB)({
                name: "보관함/좋아요"
            });
        }
    }, [
        isChatbot
    ]);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)(emotion_react_jsx_runtime_browser_esm.Fragment, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)("div", {
                css: filterCSS,
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(HorizontalFilter/* default */.Z, {
                        options: [
                            {
                                label: "전체(".concat(isStory ? (ref = query.data) === null || ref === void 0 ? void 0 : ref.pages[0].totalCount : characterQuery.totalCount, ")"),
                                value: "latest"
                            }, 
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(HorizontalFilter/* default */.Z, {
                        options: [
                            {
                                label: t("작품"),
                                value: "story"
                            },
                            {
                                label: t("캐릭터"),
                                value: "chatbot"
                            }, 
                        ],
                        selected: activeType,
                        onChange: setActiveType
                    })
                ]
            }),
            isStory && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(Pagination/* PaginationIterator */.gt, {
                name: "liked-story-list",
                query: query,
                border: true,
                inFeedAd: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(NativeInFeedAd/* default */.Z, {
                    unitKey: "story_mobile"
                }),
                children: function(item) {
                    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(ListItem/* LinkItem */.nf, {
                        to: item.theme === constants/* StoryTheme.iknow */.xb.iknow ? "/stories/".concat(item.id, "/licensed") : "/stories/".concat(item.id),
                        newTab: true,
                        hideArrow: true,
                        left: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(stories_LikedStory, LikedStoryList_objectSpread({}, item))
                    });
                }
            }),
            isChatbot && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(Pagination/* PaginationIterator */.gt, {
                name: "liked-character-list",
                query: characterQuery,
                inFeedAd: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(NativeInFeedAd/* default */.Z, {
                    unitKey: "library_mobile"
                }),
                children: function(item) {
                    var props = {
                        characterName: item.name,
                        image: item.profile_image,
                        id: item.id,
                        lastMessage: item.greeting,
                        type: item.type
                    };
                    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("div", {
                        css: chatRoomListCss,
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(ListItem/* LinkItem */.nf, {
                            hideArrow: true,
                            newTab: true,
                            left: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(chat_EmptyChatRoom, {
                                data: props,
                                onClickAvatar: handleClickAvatar,
                                onClickEnter: handleClickMoveToIntro,
                                buttonText: "대화하기"
                            })
                        })
                    }, item.id);
                }
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(Empty/* default */.Z, {
                query: characterQuery,
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("p", {
                    children: t("좋아요한 캐릭터가 아직 없어요.")
                })
            })
        ]
    });
};
/* harmony default export */ var stories_LikedStoryList = (LikedStoryList);

// EXTERNAL MODULE: ./components/common/Adfit.tsx
var Adfit = __webpack_require__(15822);
// EXTERNAL MODULE: ./.yarn/__virtual__/@emotion-react-virtual-7a26ef4a22/0/cache/@emotion-react-npm-11.11.1-a07d6a6ebd-aec3c36650.zip/node_modules/@emotion/react/dist/emotion-element-c39617d8.browser.esm.js + 2 modules
var emotion_element_c39617d8_browser_esm = __webpack_require__(71618);
// EXTERNAL MODULE: ./.yarn/__virtual__/chatie-design-system-virtual-6d39449242/0/cache/chatie-design-system-https-edc3b42f07-dc9424d6a3.zip/node_modules/chatie-design-system/dist/esm/components/icon/index.js
var icon = __webpack_require__(82740);
;// CONCATENATED MODULE: ./components/stories/ReadStory.tsx
function ReadStory_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function ReadStory_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                ReadStory_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                ReadStory_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function ReadStory_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function ReadStory_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            ReadStory_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ReadStory_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function ReadStory_objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ReadStory_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function ReadStory_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
var ReadStory_generator = undefined && undefined.__generator || function(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
function ReadStory_templateObject() {
    var data = ReadStory_taggedTemplateLiteral([
        "\n  position: relative;\n\n  > article {\n    max-width: 85%;\n  }\n\n  button {\n    position: absolute;\n    right: 0;\n    bottom: 0;\n    z-index: 1;\n    padding: ",
        "px;\n    font-size: ",
        "px;\n  }\n"
    ]);
    ReadStory_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ReadStory_templateObject1() {
    var data = ReadStory_taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transform: translateY(-50%);\n  color: ",
        ";\n  top: 50%;\n"
    ]);
    ReadStory_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}




// import { useRouter } from 'next/router';















var readStoryCSS = (0,emotion_react_browser_esm.css)(ReadStory_templateObject(), dist_esm/* Spacing.medium */.Ki.medium, dist_esm/* FontSizes.xsmall */.TS.xsmall);
var ReadStory_storySelecButtonCSS = function(theme) {
    return (0,emotion_react_browser_esm.css)(ReadStory_templateObject1(), theme.var.black);
};
var ReadStory = function(props) {
    var t = (0,esm/* useTranslation */.$G)().t;
    var id = props.id, isEdit = props.isEdit;
    var platform = (0,global/* useGlobalContext */.bN)().platform;
    var theme = (0,emotion_element_c39617d8_browser_esm.u)();
    var router = (0,next_router.useRouter)();
    var firebase = (0,analytics/* useAnalytics */.z)().firebase;
    var web = (0,webview/* useWebView */.B9)().web;
    var setLoading = (0,useLoadingStore/* useLoadingStore */.R)().setLoading;
    var ref = (0,useReadStoryStore/* useReadStoryStore */.B)(), selectedIds = ref.selectedIds, select = ref.select, cancelSelect = ref.cancelSelect;
    var isCheck = selectedIds.includes(id);
    var ref1 = (0,react.useState)([
        {
            label: t("삭제하기"),
            value: "unlike",
            isDanger: true
        }, 
    ]), actions = ref1[0];
    var optimistic = (0,utils_query/* useOptimisticUpdate */.p7)();
    var mutate = (0,es.useMutation)(function(id) {
        return (0,api_story/* deleteReadStory */.Fe)(id);
    }).mutate;
    var handleAction = (0,react.useCallback)(function(action) {
        if (action === "unlike") {
            setLoading(true);
            mutate(id, {
                onSuccess: function() {
                    optimistic.remove(constants/* QUERY_KEYS.READ_STORY.LIST */.U7.READ_STORY.LIST("latest"), id);
                    optimistic.remove(constants/* QUERY_KEYS.READ_STORY.LIST */.U7.READ_STORY.LIST("update"), id);
                },
                onSettled: function() {
                    return setLoading(false);
                }
            });
        }
    }, [
        id
    ]);
    var handleContinueRead = (0,react.useCallback)(function(e) {
        e.stopPropagation();
        var run = function() {
            var _ref = ReadStory_asyncToGenerator(function() {
                var story, url;
                return ReadStory_generator(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                (0,api_story/* fetchStory */.su)(id)
                            ];
                        case 1:
                            story = _state.sent();
                            if (!story.latestRead) {
                                return [
                                    2
                                ];
                            }
                            if (story.theme === constants/* StoryTheme.iknow */.xb.iknow) {
                                if (platform === constants/* Platform.web */.t4.web) {
                                    router.push("/stories/".concat(story.id, "/episodes/").concat(story.latestRead.episodeId, "/licensed").concat((0,misc/* toQueryString */.UK)({
                                        readFrom: constants/* EpisodeReadFrom.list */.VG.list
                                    })));
                                } else {
                                    web.openPage("/stories/".concat(story.id, "/episodes/").concat(story.latestRead.episodeId, "/licensed").concat((0,misc/* toQueryString */.UK)({
                                        readFrom: constants/* EpisodeReadFrom.list */.VG.list
                                    })));
                                }
                                return [
                                    2
                                ];
                            }
                            url = "/to".concat((0,misc/* toQueryString */.UK)({
                                url: "/stories/".concat(story.id, "/episodes/").concat(story.latestRead.episodeId).concat((0,misc/* toQueryString */.UK)({
                                    readFrom: constants/* EpisodeReadFrom.list */.VG.list
                                }))
                            }));
                            firebase.logEvent("continue_read", {
                                storyId: story.id
                            });
                            if (platform === constants/* Platform.web */.t4.web) {
                                router.push(url);
                            } else {
                                web.openPage(url);
                            }
                            return [
                                2
                            ];
                    }
                });
            });
            return function run() {
                return _ref.apply(this, arguments);
            };
        }();
        run().catch(function() {
            alert(t("이어보기 정보를 불러오는데 문제가 발생했습니다. 잠시 후 다시 시도해주세요."));
        });
    }, [
        id
    ]);
    var handleSelectStory = function(e) {
        e.stopPropagation();
        var selectedId = Number(e.currentTarget.dataset.id);
        if (isCheck) {
            cancelSelect(selectedId);
        } else {
            select(selectedId);
        }
    };
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)("article", {
        css: readStoryCSS,
        onClick: isEdit ? handleSelectStory : undefined,
        "data-id": id,
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(Story/* default */.ZP, ReadStory_objectSpreadProps(ReadStory_objectSpread({}, props), {
                tapCount: undefined,
                isLibrary: true,
                isInflow: !isEdit
            })),
            isEdit ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("button", {
                css: ReadStory_storySelecButtonCSS,
                "data-id": id,
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(icon/* Icon */.JO, {
                    icon: icon/* CheckCircle */.fU,
                    size: dist_esm/* Sizes.large */.u8.large,
                    color: isCheck ? theme.colors.main500 : theme.var.gray200
                })
            }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)(emotion_react_jsx_runtime_browser_esm.Fragment, {
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)("button", {
                        className: "icon-text",
                        onClick: handleContinueRead,
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("b", {
                                children: t("이어보기")
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(icon/* Icon */.JO, {
                                icon: icon/* ArrowRight */.ol,
                                size: dist_esm/* Sizes.xsmall */.u8.xsmall
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(ActionSheet/* KebabMenu */.f, {
                        css: Story/* storyActionCSS */.V4,
                        name: "read-story-".concat(id),
                        options: actions,
                        onSelect: handleAction
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var stories_ReadStory = (ReadStory);

;// CONCATENATED MODULE: ./components/stories/ReadStoryList.tsx
function ReadStoryList_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function ReadStoryList_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            ReadStoryList_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ReadStoryList_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function ReadStoryList_objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ReadStoryList_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}













var ReadStoryList = function(param) {
    var sort = param.sort, isEdit = param.isEdit;
    var t = (0,esm/* useTranslation */.$G)().t;
    var setReadStoryIds = (0,useReadStoryStore/* useReadStoryStore */.B)().setReadStoryIds;
    var queryKey = constants/* QUERY_KEYS.READ_STORY.LIST */.U7.READ_STORY.LIST(sort);
    var query = (0,utils_query/* usePaginationQuery */.Zl)(queryKey, function(param) {
        var pageParam = param.pageParam;
        return (0,api_story/* fetchReadStories */._e)(sort, pageParam);
    }, {
        onSuccess: function onSuccess(data) {
            setReadStoryIds(data.pages);
        }
    });
    (0,useScrollPosition/* useScrollPosition */.R)("readStoryList:".concat(sort));
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)(emotion_react_jsx_runtime_browser_esm.Fragment, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(Pagination/* PaginationIterator */.gt, {
                name: "read-story-list",
                query: query,
                border: true,
                ad: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(Adfit/* default */.Z, {
                    type: "library"
                }),
                inFeedAd: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(NativeInFeedAd/* default */.Z, {
                    unitKey: "story_mobile"
                }),
                children: function(item) {
                    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(ListItem/* LinkItem */.nf, {
                        to: item.theme === constants/* StoryTheme.iknow */.xb.iknow ? "/stories/".concat(item.id, "/licensed") : "/stories/".concat(item.id),
                        newTab: true,
                        hideArrow: true,
                        left: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(stories_ReadStory, ReadStoryList_objectSpreadProps(ReadStoryList_objectSpread({}, item), {
                            isEdit: isEdit
                        }))
                    });
                }
            }),
            query && !query.totalCount && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(Empty/* default */.Z, {
                query: query,
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("p", {
                    children: t("읽은 작품이 없습니다.")
                })
            })
        ]
    });
};
/* harmony default export */ var stories_ReadStoryList = (ReadStoryList);

// EXTERNAL MODULE: ./components/community/Post.tsx
var Post = __webpack_require__(23468);
// EXTERNAL MODULE: ./components/layout/Border.tsx
var Border = __webpack_require__(95567);
// EXTERNAL MODULE: ./components/layout/Pad.tsx
var Pad = __webpack_require__(95833);
// EXTERNAL MODULE: ./components/common/Avatar.tsx
var Avatar = __webpack_require__(81649);
// EXTERNAL MODULE: ./api/user.ts
var user = __webpack_require__(9622);
// EXTERNAL MODULE: ./utils/hook.ts
var hook = __webpack_require__(97033);
;// CONCATENATED MODULE: ./components/user/FollowingUserList.tsx
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function FollowingUserList_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function FollowingUserList_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            FollowingUserList_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function FollowingUserList_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function FollowingUserList_templateObject() {
    var data = FollowingUserList_taggedTemplateLiteral([
        "\n  white-space: nowrap;\n  overflow: auto;\n  padding: ",
        "px ",
        "px ",
        "px;\n  height: 98px;\n\n  .following-user {\n    display: inline-block;\n    width: 64px;\n    padding-top: ",
        "px;\n    text-align: center;\n\n    > div {\n      margin: 0 auto;\n    }\n\n    small {\n      display: block;\n      margin-top: ",
        "px;\n      ",
        "\n    }\n\n    &--loading {\n      color: ",
        ";\n    }\n  }\n\n  .view-more {\n    display: inline-block;\n  }\n\n  > * + * {\n    margin-left: ",
        "px;\n  }\n"
    ]);
    FollowingUserList_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function FollowingUserList_templateObject1() {
    var data = FollowingUserList_taggedTemplateLiteral([
        "\n  display: flex;\n  height: 98px;\n  align-items: center;\n  justify-content: center;\n\n  p {\n    ",
        "\n    color: ",
        ";\n  }\n"
    ]);
    FollowingUserList_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}




// import { useRouter } from 'next/router';










var followingUserListCSS = function(theme) {
    return (0,emotion_react_browser_esm.css)(FollowingUserList_templateObject(), dist_esm/* Spacing.xxsmall */.Ki.xxsmall, dist_esm/* Spacing.small */.Ki.small, dist_esm/* Spacing.medium */.Ki.medium, dist_esm/* Spacing.medium */.Ki.medium, dist_esm/* Spacing.small */.Ki.small, dist_esm/* Typography.body12 */.ZT.body12, theme.var.gray500, dist_esm/* Spacing.xxsmall */.Ki.xxsmall);
};
var emptyFollowingUserListCSS = function(theme) {
    return (0,emotion_react_browser_esm.css)(FollowingUserList_templateObject1(), dist_esm/* Typography.body14 */.ZT.body14, theme.var.gray400);
};
var FollowingUserList = function() {
    var ref;
    var t = (0,esm/* useTranslation */.$G)().t;
    var ref1 = (0,hook/* useMe */.Pi)(), me = ref1.data;
    var router = (0,next_router.useRouter)();
    var platform = (0,global/* useGlobalContext */.bN)().platform;
    var web = (0,webview/* useWebView */.B9)().web;
    var followingUserQuery = (0,es.useQuery)([
        constants/* QUERY_KEYS.FOLLOWING.FEED_USER_LIST */.U7.FOLLOWING.FEED_USER_LIST,
        me === null || me === void 0 ? void 0 : me.id
    ], function() {
        return (0,user/* fetchFollowingUsers */.TW)(me.id);
    }, {
        enabled: !!me,
        suspense: false
    });
    var ref2;
    (0,hook/* useUserMarketItemInventories */.dV)((ref2 = (ref = followingUserQuery.data) === null || ref === void 0 ? void 0 : ref.items) !== null && ref2 !== void 0 ? ref2 : []);
    var handleGoToUserPage = (0,react.useCallback)(function(user) {
        var url = "/users/".concat(user.id);
        if (platform === constants/* Platform.web */.t4.web) {
            router.push(url);
        } else {
            web.openPage(url);
        }
    }, []);
    if (!me) {
        return null;
    }
    if (followingUserQuery.isFetched) {
        if (followingUserQuery.data && followingUserQuery.data.items.length > 0) {
            var ref3;
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)("section", {
                css: followingUserListCSS,
                children: [
                    (ref3 = followingUserQuery.data) === null || ref3 === void 0 ? void 0 : ref3.items.map(function(user) {
                        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)("div", {
                            className: "following-user",
                            onClick: function() {
                                return handleGoToUserPage(user);
                            },
                            children: [
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(Avatar/* default */.ZP, FollowingUserList_objectSpread({}, user)),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("small", {
                                    className: "ellipsis",
                                    children: user.nickname
                                })
                            ]
                        }, "following-user-".concat(user.id));
                    }),
                    followingUserQuery.data.hasNext && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)("div", {
                        className: "following-user",
                        onClick: function() {
                            return web.openPage("/users/".concat(me.id, "/followings"));
                        },
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(icon/* Icon */.JO, {
                                icon: icon/* VerticalEllipsis */.oR
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("small", {
                                className: "ellipsis",
                                children: t("더보기")
                            })
                        ]
                    })
                ]
            });
        }
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("section", {
            css: emptyFollowingUserListCSS,
            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("p", {
                children: t("팔로잉하는 유저가 없습니다.")
            })
        });
    }
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("section", {
        css: followingUserListCSS,
        children: _toConsumableArray(Array(10).keys()).map(function(i) {
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)("div", {
                className: "following-user following-user--loading",
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(Avatar/* default */.ZP, {}),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("small", {
                        children: "..."
                    })
                ]
            }, "empty-avatar-".concat(i));
        })
    });
};
/* harmony default export */ var user_FollowingUserList = (FollowingUserList);

// EXTERNAL MODULE: ./api/community.ts
var community = __webpack_require__(1385);
// EXTERNAL MODULE: ./api/feed.ts
var feed = __webpack_require__(83955);
;// CONCATENATED MODULE: ./components/user/FollowingFeed.tsx
function FollowingFeed_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function FollowingFeed_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function FollowingFeed_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            FollowingFeed_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function FollowingFeed_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function FollowingFeed_objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        FollowingFeed_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || FollowingFeed_unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function FollowingFeed_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return FollowingFeed_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return FollowingFeed_arrayLikeToArray(o, minLen);
}


// import { useRouter } from 'next/router';
















var FollowingFeed = function() {
    var t = (0,esm/* useTranslation */.$G)().t;
    var feedQuery = (0,utils_query/* usePaginationQuery */.Zl)(constants/* QUERY_KEYS.FOLLOWING.FEED */.U7.FOLLOWING.FEED, function(param) {
        var pageParam = param.pageParam;
        return (0,feed/* fetchFollowingFeeds */.A)(pageParam);
    });
    (0,useScrollPosition/* useScrollPosition */.R)("followingFeed");
    var queryClient = (0,es.useQueryClient)();
    var optimistic = (0,utils_query/* useOptimisticUpdate */.p7)();
    var ref = (0,es.useMutation)(community/* togglePostLike */._P), toggleLike = ref.mutate;
    var likePost = (0,react.useCallback)(function(post) {
        toggleLike(post.id, {
            onSuccess: function() {
                optimistic.update(constants/* QUERY_KEYS.FOLLOWING.FEED */.U7.FOLLOWING.FEED, function(item) {
                    return FollowingFeed_objectSpreadProps(FollowingFeed_objectSpread({}, item), {
                        object: item.object ? FollowingFeed_objectSpreadProps(FollowingFeed_objectSpread({}, item.object), {
                            isLiked: !item.object.isLiked
                        }) : undefined
                    });
                }, {
                    id: "community-".concat(post.id)
                });
            }
        });
    }, []);
    var pollVote = (0,react.useCallback)(function(post) {
        optimistic.update(constants/* QUERY_KEYS.FOLLOWING.FEED */.U7.FOLLOWING.FEED, function(item) {
            return FollowingFeed_objectSpreadProps(FollowingFeed_objectSpread({}, item), {
                object: item.object ? FollowingFeed_objectSpreadProps(FollowingFeed_objectSpread({}, item.object), {
                    poll: post.poll
                }) : undefined
            });
        }, {
            id: "community-".concat(post.id)
        });
        var feedQueries = queryClient.getQueriesData([
            "communityFeed"
        ]);
        feedQueries.forEach(function(param) {
            var _param = _slicedToArray(param, 1), key = _param[0];
            optimistic.update(key, function(p) {
                return FollowingFeed_objectSpreadProps(FollowingFeed_objectSpread({}, p), {
                    poll: post.poll
                });
            }, {
                id: post.id
            });
        });
        queryClient.invalidateQueries([
            "communityFeed"
        ]);
        queryClient.invalidateQueries([
            "userPostList"
        ]);
        queryClient.invalidateQueries(constants/* QUERY_KEYS.POST.LIST */.U7.POST.LIST);
        queryClient.invalidateQueries(constants/* QUERY_KEYS.POST.ONE */.U7.POST.ONE(post.id));
    }, []);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)(emotion_react_jsx_runtime_browser_esm.Fragment, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(user_FollowingUserList, {}),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(Border/* default */.Z, {}),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(Pagination/* PaginationIterator */.gt, {
                name: "following-feed",
                query: feedQuery,
                border: true,
                inFeedAd: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(NativeInFeedAd/* default */.Z, {
                    unitKey: "feed_default_mobile"
                }),
                children: function(item) {
                    if (!item.object) {
                        return null;
                    }
                    if (item.objectType === "story") {
                        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(ListItem/* LinkItem */.nf, {
                            hideArrow: true,
                            newTab: true,
                            to: "/stories/".concat(item.object.id),
                            left: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(Story/* default */.ZP, FollowingFeed_objectSpread({}, item.object))
                        });
                    }
                    if (item.objectType === "community") {
                        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(ListItem/* LinkItem */.nf, {
                            to: "/feeds/posts/".concat(item.objectId),
                            hideArrow: true,
                            newTab: true,
                            left: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(Pad/* default */.Z, {
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(Post/* default */.Z, FollowingFeed_objectSpreadProps(FollowingFeed_objectSpread({}, item.object), {
                                    clip: true,
                                    onLike: likePost,
                                    onPollVote: pollVote
                                }))
                            })
                        });
                    }
                    return null;
                }
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(Empty/* default */.Z, {
                query: feedQuery,
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("p", {
                    children: t("다른 채티즈를 팔로우를 하여 나만의 피드를 구성해보세요!")
                })
            })
        ]
    });
};
/* harmony default export */ var user_FollowingFeed = (FollowingFeed);

// EXTERNAL MODULE: ./contexts/auth.tsx
var auth = __webpack_require__(71727);
;// CONCATENATED MODULE: ./pages/library.tsx
function library_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function library_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                library_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                library_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function library_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function library_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            library_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function library_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function library_objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        library_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function library_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
var library_generator = undefined && undefined.__generator || function(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
function library_templateObject() {
    var data = library_taggedTemplateLiteral([
        "\n  .bottomButton {\n    bottom: ",
        "px;\n  }\n"
    ]);
    library_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function library_templateObject1() {
    var data = library_taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: row;\n  text-align: left;\n  padding: ",
        "px ",
        "px;\n  border-bottom: 1px solid ",
        ";\n  ",
        ";\n  z-index: 3;\n  background-color: ",
        ";\n  height: 43px;\n\n  &::after {\n    content: '';\n    display: table;\n    clear: both;\n  }\n\n  ",
        " {\n    padding: ",
        "px ",
        "px;\n  }\n\n  ",
        " {\n    padding: ",
        "px ",
        "px;\n  }\n"
    ]);
    library_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function library_templateObject2() {
    var data = library_taggedTemplateLiteral([
        "\n  margin-left: auto;\n\n  span {\n    display: inline-block;\n    height: 12px;\n    border-left: 1px solid ",
        ";\n    margin: 0 ",
        "px;\n    vertical-align: middle;\n  }\n"
    ]);
    library_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = library_taggedTemplateLiteral([
        "\n  font-size: ",
        "px;\n  color: ",
        ";\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}



// import { useRouter } from 'next/router';



























var LIBRARY_SIZE = "library";
/**
 * Pages
 */ var libraryCSS = function(diff) {
    return (0,emotion_react_browser_esm.css)(library_templateObject(), diff);
};
var readStoryFilterCSS = function(theme) {
    return (0,emotion_react_browser_esm.css)(library_templateObject1(), dist_esm/* Spacing.small */.Ki.small, dist_esm/* Spacing.medium */.Ki.medium, theme.border.light, (0,css/* sticky */.CA)(Push/* PushSize.tab */.z.tab), theme.var.white, css/* media.tablet */.BC.tablet, dist_esm/* Spacing.small */.Ki.small, dist_esm/* Spacing.xlarge */.Ki.xlarge, css/* media.desktop */.BC.desktop, dist_esm/* Spacing.small */.Ki.small, dist_esm/* Spacing.xxlarge */.Ki.xxlarge);
};
var editButtonGroupCSS = function(theme) {
    return (0,emotion_react_browser_esm.css)(library_templateObject2(), theme.border.light, dist_esm/* Spacing.xsmall */.Ki.xsmall);
};
var editButtonCSS = function(theme) {
    return (0,emotion_react_browser_esm.css)(_templateObject3(), dist_esm/* FontSizes.xsmall */.TS.xsmall, theme.var.black);
};
var LibraryDetail = function(param) {
    var isCheming = param.isCheming;
    var t = (0,esm/* useTranslation */.$G)().t;
    var ref = stores_useVpDiffStore(), diff = ref.diff, setDiff = ref.setDiff;
    var initialHeight = window.innerHeight;
    (0,hook/* useScreen */.EV)("보관함");
    var pendingUpdate = false;
    var tab = (0,Tab/* useTab */.x)(isCheming ? [
        {
            label: t("내 대화"),
            value: "chat-library"
        }
    ] : [
        {
            label: t("읽은 작품"),
            value: "read-stories"
        },
        {
            label: t("플레이"),
            value: "chat-library"
        },
        {
            label: t("팔로잉"),
            value: "following-feed"
        },
        {
            label: t("좋아요"),
            value: "liked-stories"
        }, 
    ], {
        replace: true
    });
    var activeTab = tab.activeTab;
    var ref1 = (0,useReadStoryStore/* useReadStoryStore */.B)(), deselectAll = ref1.deselectAll, selectAll = ref1.selectAll, selectedIds = ref1.selectedIds;
    var removeReadStories = (0,useStoryQuery/* useStoryQuery */.c)().removeReadStories;
    var queryClient = (0,es.useQueryClient)();
    var ref2 = (0,react.useState)("latest"), sort = ref2[0], setSort = ref2[1];
    var ref3 = (0,react.useState)(false), isEdit = ref3[0], setIsEdit = ref3[1];
    var ref4 = (0,react.useState)(false), isSelectAll = ref4[0], setIsSelectAll = ref4[1];
    (0,react.useEffect)(function() {
        deselectAll();
    }, [
        activeTab
    ]);
    var handleToggleEditButton = function() {
        setIsEdit(!isEdit);
        if (isEdit) {
            deselectAll();
        }
    };
    var handleToggleSelectAllButton = function() {
        setIsSelectAll(!isSelectAll);
        if (isSelectAll) {
            deselectAll();
        } else {
            selectAll();
        }
    };
    var handleClickDeleteButton = function() {
        var _ref = library_asyncToGenerator(function() {
            return library_generator(this, function(_state) {
                if (confirm("읽은 작품을 삭제하시겠습니까?")) {
                    removeReadStories(selectedIds, {
                        onSuccess: function onSuccess() {
                            setIsEdit(false);
                            deselectAll();
                            queryClient.invalidateQueries(constants/* QUERY_KEYS.READ_STORY.LIST */.U7.READ_STORY.LIST("latest"));
                            queryClient.invalidateQueries(constants/* QUERY_KEYS.READ_STORY.LIST */.U7.READ_STORY.LIST("update"));
                        },
                        onError: function onError() {
                            alert("다시 시도해주시길 바랍니다.");
                        }
                    });
                }
                return [
                    2
                ];
            });
        });
        return function handleClickDeleteButton() {
            return _ref.apply(this, arguments);
        };
    }();
    var viewportHandler = function() {
        if (pendingUpdate) return;
        pendingUpdate = true;
        requestAnimationFrame(function() {
            var diff = window.innerHeight - initialHeight;
            pendingUpdate = false;
            var height = window.innerHeight;
            if (height > initialHeight) {
                setDiff(diff);
            }
        });
    };
    (0,react.useEffect)(function() {
        var ref;
        viewportHandler();
        (ref = window.visualViewport) === null || ref === void 0 ? void 0 : ref.addEventListener("resize", viewportHandler);
        return function() {
            var ref;
            (ref = window.visualViewport) === null || ref === void 0 ? void 0 : ref.removeEventListener("resize", viewportHandler);
        };
    }, []);
    (0,react.useEffect)(function() {
        if (activeTab === "chat-library") {
            (0,misc/* setFlow */.kB)({
                isDelete: true
            });
            (0,misc/* setFlow */.kB)({
                name: "보관함/플레이"
            });
        }
    }, [
        activeTab
    ]);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)("div", {
        css: libraryCSS(diff),
        children: [
            !isCheming && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(Tab/* default */.Z, library_objectSpreadProps(library_objectSpread({}, tab), {
                stickyAt: 0,
                fit: true
            })),
            activeTab === "read-stories" && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)("div", {
                css: readStoryFilterCSS,
                children: [
                    !isEdit && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(HorizontalFilter/* default */.Z, {
                        options: [
                            {
                                label: t("최근본 순"),
                                value: "latest"
                            },
                            {
                                label: t("업데이트 순"),
                                value: "update"
                            }, 
                        ],
                        selected: sort,
                        onChange: setSort
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)("div", {
                        css: editButtonGroupCSS,
                        children: [
                            isEdit && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)(emotion_react_jsx_runtime_browser_esm.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(react.Fragment, {
                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("button", {
                                            css: editButtonCSS,
                                            onClick: handleToggleSelectAllButton,
                                            children: t(isSelectAll ? "전체선택 해제" : "전체선택")
                                        })
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("span", {})
                                ]
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(react.Fragment, {
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("button", {
                                    css: editButtonCSS,
                                    onClick: handleToggleEditButton,
                                    children: t(isEdit ? "취소" : "편집")
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)(SafeArea/* default */.Z, {
                bottom: true,
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)(react.Suspense, {
                        fallback: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(SkeletonList/* default */.Z, {
                            skeleton: StorySkeleton/* default */.Z
                        }),
                        children: [
                            activeTab === "read-stories" && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(stories_ReadStoryList, {
                                sort: sort,
                                isEdit: isEdit
                            }),
                            activeTab === "following-feed" && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(user_FollowingFeed, {})
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(react.Suspense, {
                        fallback: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(SkeletonList/* default */.Z, {
                            skeleton: StorySkeleton/* default */.Z
                        }),
                        children: activeTab === "liked-stories" && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(stories_LikedStoryList, {})
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(react.Suspense, {
                        fallback: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(SkeletonList/* default */.Z, {
                            skeleton: CharacterSkeleton/* default */.Z
                        }),
                        children: activeTab === "chat-library" && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(ChatRoomList/* default */.Z, {
                            isCheming: isCheming
                        })
                    }),
                    isEdit && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(BottomButton/* default */.Z, {
                        push: true,
                        className: "bottomButton",
                        text: t("선택 항목 삭제"),
                        onClick: handleClickDeleteButton
                    })
                ]
            })
        ]
    });
};
var LibraryPage = function(param) {
    var isCheming = param.isCheming;
    var t = (0,esm/* useTranslation */.$G)().t;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)(Layout/* default */.Z, {
        isPush: true,
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(Seo/* default */.Z, {
                title: t("보관함")
            }),
            isCheming && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(Header/* default */.Z, {
                title: t("보관함")
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(react.Suspense, {
                fallback: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(Loading/* default */.ZP, {
                    center: true
                }),
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(LibraryDetail, {
                    isCheming: isCheming
                })
            })
        ]
    });
};
// const LibraryLoading = () => {
//   const { t } = useTranslation();
//   const tab = useTab<LibraryTab>(
//     [
//       { label: t('읽은 작품'), value: 'read-stories' },
//       { label: t('팔로잉'), value: 'following-feed' },
//       { label: t('좋아요'), value: 'liked-stories' },
//     ],
//     { replace: true }
//   );
//   return (
//     <Layout>
//       <Seo title={t('보관함')} />
//       <Tab {...tab} stickyAt={0} fit />
//       <SkeletonList skeleton={StorySkeleton} />
//     </Layout>
//   );
// };
/* harmony default export */ var library = ((0,auth/* withAuth */.QO)(LibraryPage)); // export default withAuth(LibraryPage, { LoadingComponent: LibraryLoading });


/***/ })

}]);